import General from "../utils/general";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {

  logoH() {
    return "data:image/png;base64,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";
    },

  logoUP(){
    return "data:image/png;base64,iVBORw0pYKl+P079v+7GjOfVw59mXD8T0Sfx8cCDAAoUczG+LCUUAAAAABJRU5ErkJggg==";
  },
  setting(logoalign = null) {
    return {
      header: [
        {
          stack: [
            {
              image: this.logoH(),
              width: 180,
              height: 70,
              alignment: logoalign,
            },
          ],
          margin: [35, 15, 35, 10],
        },
      ],
      headerUP: [
        {
          stack: [
            {
              image: this.logoUP(),
              width: 350,
              height: 52,
              alignment: logoalign,
            },
          ],
          margin: [35, 15, 35, 0],
        },
      ],
      headerc: [
        {
          stack: [
            {
              image:
                "data:image/jpeg;base64,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",
              width: 100,
              height: 148,
              alignment: "center",
            },
          ],
          margin: [35, 25, 35, 0],
          alignment: "center",
        },
      ],
      
      footer: (currentPage, pageCount, pageSize) => {
        return [
          {
            margin: [5, 0, 5, 5],
            canvas: [
              {
                type: "line",
                x1: 22,
                y1: 2,
                x2: pageSize.width - 33,
                y2: 2,
                lineWidth: 1,
                lineColor: "#F44336",
              },
            ],
          },
          {
            columns: [
              {
                fontSize: 7,
                text: "Dirección General de Formación de Maestros",
                alignment: "left",
                marginLeft: 28,
              },
              {
                fontSize: 7,
                text: "Página " + currentPage.toString() + " de " + pageCount,
                alignment: "right",
                marginRight: 28,
              },
            ],
          },
        ];
      },
      footer2:async (datos, codigo)=>{
        return [
          {

            columns: [
              {
                qr: `|CI-${datos.cedula_dni}|FN_${datos.fecha_nacimiento}|NO-${codigo}|GESTION-${datos.gestion}`,
                marginTop: 10,
                foreground: "#212121",
                fit: "95",
                marginLeft: 28,
              },
              {
                width: "50%",
                fontSize: 10,
                color: "#212121",
                text: "_______________________________\nFIRMA DEL POSTULANTE",
                alignment: "center",
                marginTop: 50,
              },
              {
                marginTop: 10,
                image: await this.getBase64ImageFromURL(General.getServe()+"admision/"+datos.gestion+"/"+datos.ruta_imagen),
                width: 100,
                height: 100,
                alignment: "right",
                marginRight: 28,
              },
            ],
          }
        ];
      },
      footer3: (currentPage, pageCount, pageSize) => {
        if(currentPage==1){
          return [
            {
              margin: [5, 0, 5, 5],
              canvas: [
                {
                  type: "line",
                  x1: 22,
                  y1: 2,
                  x2: pageSize.width - 33,
                  y2: 2,
                  lineWidth: 1,
                  lineColor: "#F44336",
                },
              ],
            },
          ];
        }
        return [
          {
            margin: [5, 0, 5, 5],
            canvas: [
              {
                type: "line",
                x1: 22,
                y1: 2,
                x2: pageSize.width - 33,
                y2: 2,
                lineWidth: 1,
                lineColor: "#F44336",
              },
            ],
          },
          {
            columns: [
              {
                fontSize: 7,
                text: "Dirección General de Formación de Maestros",
                alignment: "left",
                marginLeft: 28,
              },
              {
                fontSize: 7,
                text: "Página " + currentPage.toString() + " de " + pageCount,
                alignment: "right",
                marginRight: 28,
              },
            ],
          },
        ];
      },
    };
  },
  async bodyPDF(datos, codigo) {
    let nombre = `${datos.paterno ? datos.paterno : ""} ${
      datos.materno ? datos.materno : ""
    } ${datos.nombres}`;
    let contentBody = [
      {
        columns: [
          {
            width: "100%",
            stack: [
              {
                fontSize: 14,
                bold: true,
                color: "#212121",
                text: "FORMULARIO DE POSTULACIÓN",
                alignment: "center",
              },
              {
                fontSize: 13,
                bold: true,
                color: "#212121",
                text: `PROCESO DE ADMISIÓN - GESTIÓN ${datos.gestion}`,
                alignment: "center",
              },
              {
                fontSize: 9,
                bold: true,
                color: "#212121",
                text: `Fecha de postulación: ${this.formatDate(
                  datos.fecha_registro
                )}`,
                alignment: "center",
              },
            ],
          }, 
        ],
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["21%", "20%", "19%", "40%"],
          body: [
            [
              {
                text: "DATOS PERSONALES",
                bold: true,
                colSpan: 4,
                fillColor: "#dddddd",
              },
              {},
              {},
              {},
            ],
            [
              {
                text: "Apellidos y Nombres: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: nombre, colSpan: 3 },
              {},
              {},
            ],
            [
              {
                text: "Cédula de Identidad: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: datos.cedula_dni },
              { text: "Género: ", bold: true, fillColor: "#dddddd" },
              datos.genero,
            ],
            [
              {
                text: "Fecha de Nacimiento: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: this.formatDate(datos.fecha_nacimiento) },
              {
                text: "Departamento: ",
                bold: true,
                fillColor: "#dddddd",
              },
              datos.departamento,
            ],
            [
              {
                text: "Teléfono/Celular: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: datos.celular },
              { text: "Correo: ", bold: true, fillColor: "#dddddd" },
              datos.correo_electronico,
            ],
            [
              { text: "Dirección: ", bold: true, fillColor: "#dddddd" },
              { text: datos.direccion, colSpan: 3 },
              {},
              {},
            ],
          
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["25%", "75%"],
          body: [
            [
              {
                text: "DATOS DE EGRESO",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              {
                text: "Unidad Educativa o CEA: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: datos.unidad_educativa },
            ],
            [
              { text: "Gestión: ", bold: true, fillColor: "#dddddd" },
              { text: datos.gestion_egreso },
            ],
            [
              { text: "Promedio de Notas: ", bold: true, fillColor: "#dddddd" },
              { text: "No se encontró registros en el sistema." },
            ]
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["25%", "75%"],
       //   widths: ["21%", "30%", "19%", "30%"],
          body: [
            [
              {
                text: "DATOS DE POSTULACIÓN",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              { text: "ESFM/UA: ", bold: true, fillColor: "#dddddd" },
              { text: datos.institucion },
              
            ],
            [
              {
                text: "Especialidad: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: datos.especialidad },
              
            ],
            
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["25%", "75%"],
          body: [
            [
              {
                text: (datos.sigla_modalidad === "B2" || datos.sigla_modalidad === "B3" || datos.sigla_modalidad === "B5")?"DATOS DE LENGUA ORIGINARIA-MATERNA":(datos.sigla_modalidad === "B1" || datos.sigla_modalidad === "B4")?"DATOS DE LENGUA ORIGINARIA":"DATOS DE LENGUA",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              { text: "Lengua: ", bold: true, fillColor: "#dddddd" },
              { text: datos.lengua },
            ],
            [
              {
                text: "Pueblo o Nación: ",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: datos.nacion_pueblo ? datos.nacion_pueblo : "",
              },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["100%"],
          body: [
            [
              {
                text: "DECLARACIÓN JURADA",
                bold: true,
                fillColor: "#dddddd",
              },
            ],
            [{ text: "" }],
          ],
        },
      },
      {
        stack: [
          [
            {
              text: `Yo, ${nombre.toUpperCase()}, hábil por derecho con Cédula de Identidad N° ${
                datos.cedula_dni
              }, de manera voluntaria acepto los términos establecidos en el Reglamento y la ${
                datos.cite
              } del ${datos.descripcion} de la Gestión ${
                datos.gestion
              }.`,
              alignment: "justify",
              fontSize: 7.5,
            },
          ],
          [
            {
              fontSize: 7.5,
              ul: [
                "Cumplo a cabalidad con los requisitos establecidos en el presente Reglamento y Convocatoria Pública Nº 001/2025.",
                "Todos los datos proporcionados son fidedignos y verídicos, autorizando su verificación, en caso de ser necesario.",
                "Acepto los resultados del proceso de admisión y resultados finales publicados oficialmente por el Ministerio de Educación.",
                "El postulante que incurra en cualquier irregularidad en el Proceso de Admisión será excluido en cualquiera de sus fases.",
              ],
              alignment: "justify",
            },
          ],
          
          
        ],
      },
      {
        columns: [
          {
            width: "15%",
            fontSize: 8,
            color: "#000000",
            text: datos.codigo,
            alignment: "center",
            marginTop: 8,
            marginBottom:0,
          },
          {
          },
          {
          },
        ],
      },
      {
        columns: [
          {
            qr: `|CI-${datos.cedula_dni}|FN_${datos.fecha_nacimiento}|NO-${codigo}|GESTION-${datos.gestion}`,
            marginTop: 0,
            foreground: "#212121",
            fit: "95",
          },
          {
            width: "60%",
            fontSize: 10,
            color: "#212121",
            text: "_______________________________\nFIRMA DEL POSTULANTE",
            alignment: "center",
            marginTop: 50,
          },
          {
            marginTop: 0,
            image: await this.getBase64ImageFromURL(General.getServe()+"admision/"+datos.gestion+"/"+datos.ruta_imagen),
            width: 85,
            height: 85,
          },
        ],
      },
    ];
  
   
    // const aheadB14 = {
    //   pageBreak: "before",
    //   stack: [
    //     {
    //       fontSize: 14,
    //       bold: true,
    //       color: "#212121",
    //       text: "FORMULARIO DE EVALUACIÓN DE LENGUA ORIGINARIA",
    //       alignment: "center",
    //       marginTop: 1,
    //     },
    //     {
    //       fontSize: 13,
    //       bold: true,
    //       color: "#212121",
    //       text: `MODALIDAD ${datos.sigla_modalidad} - ${datos.gestion}`,
    //       alignment: "center",
    //     },
    //     {
    //       fontSize: 10,
    //       bold: true,
    //       color: "#212121",
    //       text: datos.especialidad,
    //       alignment: "center",
    //     },
    //   ],
    // };
    
    // const aperson = {
    //   marginTop: 1,
    //   marginBottom: 1,
    //   fontSize: 9,
    //   layout: {
    //     hLineWidth: function (i, node) {
    //       if (i === 0 || i === node.table.body.length) {
    //         return 0;
    //       }
    //       return i === node.table.headerRows ? 2 : 1;
    //     },
    //     vLineWidth: function (i) {
    //       return i * 0;
    //     },
    //     hLineColor: function (i) {
    //       return i === 1 ? "#fff" : "#aaa";
    //     },
    //   },
    //   table: {
    //     widths: ["12%", "53%", "19%", "16%"],
    //     body: [
    //       [
    //         {
    //           text: "Postulante: ",
    //           bold: true,
    //           fillColor: "#dddddd",
    //         },
    //         { text: nombre, fillColor: "#EEEEEE" },
    //         {
    //           text: "Cédula de Identidad: ",
    //           bold: true,
    //           fillColor: "#dddddd",
    //         },
    //         { text: datos.cedula_dni, fillColor: "#EEEEEE" },
    //       ],
    //       [
    //         {
    //           text: "ESFM/UA: ",
    //           bold: true,
    //           fillColor: "#dddddd",
    //         },
    //         {
    //           text: datos.institucion,
    //           fillColor: "#EEEEEE",
    //           colSpan: 3,
    //         },
    //         {},
    //         {},
    //       ],
    //     ],
    //   },
    // };
    if (datos.sigla_modalidad === "A") {
      //agregar informacion del deposito
      contentBody[1].table.body.push(
        [
          {
            text: "Nro. de Depósito: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: datos.numero },
          {
            text: "Fecha de Depósito: ",
            bold: true,
            fillColor: "#dddddd",
          },
          this.formatDate(datos.fecha),
        ],
      );

      
    }

    if(datos.especialidad_opcion && datos.especialidad_opcion!==""){
      contentBody[3].table.body.push(
         [
              { text: "ESFM/UA 2da. Opción: ", bold: true, fillColor: "#dddddd" },
              { text: datos.institucion_opcion },
             

            ],
            [
              {
                text: "Especialidad 2da. Opción: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: datos.especialidad_opcion },
           
            ],
      )
    }


      if(datos.informacion_academica != "null" || datos.informacion_academica != null || datos.informacion_academica!==""){
        let informacion_academica =datos.informacion_academica!=="" ? JSON.parse(datos.informacion_academica):"";
        
        if(Object.keys(informacion_academica).length > 0 ){
          let gestiones = "";
          informacion_academica.forEach(dato=>{
              gestiones= gestiones+dato.gestion_tipo_id+", ";}
            );


          contentBody[2].table.body[3]= [
              { text: "Promedio de Notas: ", bold: true, fillColor: "#dddddd" },
              { text: "Se encontró el promedio de gestiones "+gestiones+"en sistema." },
            ]
          
          // contentBody[2]={
          //   marginTop: 10,
          //   fontSize: 9,
          //   layout: "lightHorizontalLines",
          //   table: {
          //     headerRows: 1,
          //     widths: ["10%","10%", "25%","45%", "10%"],
          //     body: [
          //       [
          //         {
          //           text: "DATOS DE EGRESO",
          //           bold: true,
          //           colSpan: 5,
          //           fillColor: "#dddddd",
          //         },
          //         {},
          //         {},
          //         {},
          //         {},
          //       ],
          //       [
          //         {
          //           text: "GESTIÓN",
          //           bold: true,
          //           fillColor: "#dddddd",
          //         },
          //         {
          //           text: "GRADO",
          //           bold: true,
          //           fillColor: "#dddddd",
          //         },
          //         {text: "UNIDAD EDUCATIVA",
          //         bold: true,
          //         fillColor: "#dddddd",},
          //         {text: "UBICACIÓN",
          //         bold: true,
          //         fillColor: "#dddddd",},
          //         {text: "PROMEDIO",
          //         bold: true,
          //         fillColor: "#dddddd",},
          //       ],
              
          //     ],
          //   },
          // };
          
            // informacion_academica.forEach(dato=>{
            //   contentBody[2].table.body.push([
            //     {text:dato.gestion_tipo_id},
            //     {text:dato.grado.toUpperCase()},
            //     {text:dato.institucioneducativa.toUpperCase()},
            //     {text:`Departamento: ${dato.des_dep.toUpperCase()}, Provincia: ${dato.des_pro.toUpperCase()}, Municipio: ${dato.des_sec_mun.toUpperCase()}, Distrito: ${dato.distrito.toUpperCase()} \n Zona: ${dato.zona.toUpperCase()}, Dirección: ${dato.direccion.toUpperCase()}`},
            //     {text: parseFloat(dato.promedio).toFixed(3)}])
            //   }
            // );
        
             
        }
    

    }


    if (datos.discapacidad_descripcion) {
              if(datos.discapacidad_descripcion == 'VISUAL'){
                contentBody.splice(5,0,{
            marginTop: 10,
            fontSize: 9,
            layout: "lightHorizontalLines",
            table: {
              headerRows: 1,
              widths: ["21%", "30%", "19%", "30%"],
              body: [
                [
                  {
                    text: "DATOS DE DISCAPACIDAD",
                    bold: true,
                    colSpan: 4,
                    fillColor: "#dddddd",
                  },
                  {},
                  {},
                  {},
                ],
                [
                {
                  text: "Tipo Discapacidad: ",
                  bold: true,
                  fillColor: "#dddddd",
                },
                { text: datos.discapacidad_descripcion },
                {
                  text: "Grado Discapacidad",
                  bold: true,
                  fillColor: "#dddddd",
                },
                { text: datos.discapacidad_grado },
              ],
                [
                  {
                      },
                  {  },
                  {
                    text: "Fecha Emisión: ",
                    bold: true,
                    fillColor: "#dddddd",
                  },
                  { text: datos.fecha_emision },

                ]
              ],
            },
          }); 
              }else{
                contentBody.splice(5,0,{
            marginTop: 10,
            fontSize: 9,
            layout: "lightHorizontalLines",
            table: {
              headerRows: 1,
              widths: ["21%", "30%", "19%", "30%"],
              body: [
                [
                  {
                    text: "DATOS DE DISCAPACIDAD",
                    bold: true,
                    colSpan: 4,
                    fillColor: "#dddddd",
                  },
                  {},
                  {},
                  {},
                ],
                [
            {
              text: "Tipo Discapacidad: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: datos.discapacidad_descripcion },
            {
              text: "Grado Discapacidad",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: datos.discapacidad_grado },
          ],
            [
              {
                text: "Porcentaje (%): ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: datos.grado },

              {
                text: "Fecha Emisión: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: datos.fecha_emision },

            ]
              ],
            },
          }); 
              }

          }

    return contentBody;
  },
  // MODALIDAD A
  // 11 = EDUCACIÓN INICIAL EN FAMILIA COMUNITARIA
  // 51 = EDUCACIÓN FÍSICA Y DEPORTES
  // 53 = EDUCACIÓN MUSICAL
  // 54 = ARTES PLÁSTICAS Y VISUALES
  // 59 = AGROPECUARIA
  // 66 = CARPINTERÍA INDUSTRIAL EN MADERA Y METAL
  // 68 = TRANSFORMACIÓN  DE ALIMENTOS Y GASTRONOMÍA
  // 69 = INDUSTRIA TEXTIL Y CONFECCIONES
  // 70 = MECÁNICA AUTOMOTRIZ
  // 71 = ELECTRICIDAD Y ELECTRÓNICA
  // 74 = ELECTROMECANICA
  // MODALIDAD B
  // 11 = EDUCACIÓN INICIAL EN FAMILIA COMUNITARIA repite
  // 21 = EDUCACIÓN PRIMARIA COMUNITARIA VOCACIONAL
  // 31 = CIENCIAS NATURALES: BIOLOGÍA - GEOGRAFÍA
  // 32 = CIENCIAS NATURALES: FÍSICA - QUÍMICA
  // 36 = COSMOVISIONES, FILOSOFÍAS Y SICOLOGÍA
  // 37 = MATEMÁTICA
  // 38 = COMUNICACIÓN Y LENGUAJES: LENGUA EXTRANJERA (INGLÉS)
  // 39 = COMUNICACIÓN Y LENGUAJES: LENGUA CASTELLANA
  // 51 = EDUCACIÓN FÍSICA Y DEPORTES repite
  // 52 = VALORES, ESPIRITUALIDAD Y RELIGIONES  repite
  // 53 = EDUCACIÓN MUSICAL repite
  // 54 = ARTES PLÁSTICAS Y VISUALES  repite
  // 59 = AGROPECUARIA  repite
  // 66 = CARPINTERÍA INDUSTRIAL EN MADERA Y METAL
  // 68 = TRANSFORMACIÓN  DE ALIMENTOS Y GASTRONOMÍA
  // 69 = INDUSTRIA TEXTIL Y CONFECCIONES
  // 70 = MECÁNICA AUTOMOTRIZ
  // 71 = ELECTRICIDAD Y ELECTRÓNICA
  // 74 = ELECTROMECANICA
  async aptitud(modalidad, especialidad_id,alto) {
    let aform = null;
    try {
      aform = {
        marginTop: 8,
        image: await this.getBase64ImageFromURL(General.getServe()+"admision/evaluaciones/"+modalidad+"/"+especialidad_id+".png"),
        width: 535,
        //height: 600,
      };
      if(alto == 2){
        aform.height = 600;
      }
    } catch (error) {
      aform = { text: "" };
    }
    //  aform.image=await this.getBase64ImageFromURL(General.getServe()+"admision/evaluaciones/"+"eval.png");
    return aform;
/*
    if (modalidad == "A") {
      switch (especialidad_id) {
        case 11:
          aform = {
            marginTop: 8,
            image: await this.getBase64ImageFromURL(General.getServe()+"admision/evaluaciones/"+modalidad+"/"+especialidad_id+".png"),
            width: 535,
          };
          break;
        case 5101:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 5101:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 5110:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 5111:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 53:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 54:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 59:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 66:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 68:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 69:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 70:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 71:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 74:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        default:
          aform = { text: "" };
          break;
      }

    } else if (
      modalidad == "B1" ||
      modalidad == "B2" ||
      modalidad == "B3" ||
      modalidad == "B4"
    ) {

      switch (especialidad_id) {
        case 11:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 21:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 31:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 32:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 33:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
            height: 610,
          };
          break;
        case 36:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 37:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 38:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 39:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 610:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 611:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 612:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 613:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 614:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 615:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 52:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 53:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 54:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 59:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 66:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 68:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 69:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 70:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 71:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        case 74:
          aform = {
            marginTop: 8,
            image: "",
            width: 535,
          };
          break;
        default:
          aform = { text: "" };
          break;
      }
    } else {
      aform = { text: "" };
    }
    */
  
   
  },
  async bodyCentralizadorPDF(datos, modalidad) {
    let esp_con_pa = [51,53,54,59,68,69,70,71];
    const nombre = `${datos.paterno ? datos.paterno : ""} ${
      datos.materno ? datos.materno : ""
    } ${datos.nombres}`;
    const datosRequisitos = JSON.parse(datos.requisitos);
    let requisitos = [
      [
        {
          text: "No.",
          bold: true,
          fillColor: "#dddddd",
        },
        {
          text: "VERIFICACIÓN DE CUMPLIMIENTO DE REQUISITOS",
          bold: true,
          fillColor: "#dddddd",
        },
        { text: "RESPUESTA", bold: true, fillColor: "#dddddd" },
      ],
    ];
    for (const key in datosRequisitos) {
      const requ = datosRequisitos[key].respuestas;
      let item = await requ.find(
        (x) => x.value === datosRequisitos[key].cumple
      );
      requisitos.push([
        { text: datosRequisitos[key].numeracion },
        { text: datosRequisitos[key].descripcion },
        { text: item ? item.label : "" },
      ]);
    }
    const promedios = JSON.parse(datos.promedios);
    const promedio_final = JSON.parse(datos.promedio_final);
    const datosComision = JSON.parse(datos.comision);
    let comision = [
      [
        { text: "CARGO", bold: true, fillColor: "#dddddd" },
        { text: "NOMBRES Y APELLIDOS", bold: true, fillColor: "#dddddd" },
        { text: "FIRMAS", bold: true, fillColor: "#dddddd" },
      ],
    ];
    for (const key in datosComision) {
      comision.push([
        { text: datosComision[key].cargo, margin: [0, 3, 2, 0] },
        { text: datosComision[key].nombre, margin: [0, 3, 2, 0] },
        { text: "" },
      ]);
    }

    let contentBody = [
      {
        columns: [
          {
            width: "100%",
            stack: [
              {
                fontSize: 14,
                bold: true,
                color: "#212121",
                text: "FORMULARIO CENTRALIZADOR",
                alignment: "center",
                marginTop: -10,
              },
              {
                fontSize: 13,
                bold: true,
                color: "#212121",
                text: `MODALIDAD ${modalidad} - ${datos.gestion}`,
                alignment: "center",
              },
            ],
          },
        ],
      },
      {
        marginTop: 7,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["21%", "20%", "19%", "40%"],
          body: [
            [
              {
                text: "DATOS GENERALES",
                bold: true,
                colSpan: 4,
                fillColor: "#dddddd",
              },
              {},
              {},
              {},
            ],
            [
              {
                text: "Apellidos y Nombres: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: nombre, colSpan: 3 },
              {},
              {},
            ],
            [
              {
                text: "Cédula de Identidad: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: datos.cedula_dni, colSpan: 3 },
              {},
              {},
            ],
            [
              {
                text: "ESFM/UA: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: datos.institucion, colSpan: 3 },
              {},
              {},
            ],
            [
              {
                text: "Especialidad: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: datos.especialidad, colSpan: 3 },
              {},
              {},
            ],
          ],
        },
      },
      {
        marginTop: 7,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["4%", "86%", "10%"],
          body: requisitos,
        },
      },
      {
        marginTop: 7,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["86%", "14%"],
          body: [
            [
              {
                text: "VALORACIÓN DE LENGUA ORIGINARIA",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "RESULTADO",
                bold: true,
                fillColor: "#dddddd",
              },
            ],
            [
              {
                text: `Si la puntuación obtenida es mayor o igual a ${modalidad== "B1" ? "61" : "61"} , la/el postulante es habilitado/a.`,
              },
              {
                text: (modalidad== "B1" || modalidad== "B4") //datos.nota_lengua && datos.nota_lengua > 0
                  ?  `${datos.nota_lengua}\n${
                      (datos.nota_lengua > 60)? "HABILITADO" :"NO HABILITADO"
                    }`
                  : "NO CORRESPONDE",
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
      },
      {
        marginTop: 7,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["86%", "14%"],
          body: [
            [
              {
                text: "VALORACIÓN DE LA PRUEBA DE APTITUD",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "RESULTADO",
                bold: true,
                fillColor: "#dddddd",
              },
            ],
            [
              {
                text: `Si la puntuación obtenida es mayor o igual a ${modalidad== "B1" ? "61" : "61"}, la/el postulante es habilitado/a.`,
              },
              {
                text: ((modalidad== "B1" || modalidad== "B4"|| modalidad== "B5") && !esp_con_pa.includes(datos.especialidad_id))?"NO CORRESPONDE":
                    (datos.nota_aptitud ? `${datos.nota_aptitud}\n${(datos.nota_aptitud > 60)? "HABILITADO" : "NO HABILITADO"}` : "NO HABILITADO"),
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
      },
      {
        marginTop: 7,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["14%", "14%", "14%", "14%", "14%", "14%", "16%"],
          body: [
            [
              {
                text: "COMPUTO DE PROMEDIOS DE LOS CERTIFICADOS O LIBRETAS DE EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA",
                bold: true,
                fillColor: "#dddddd",
                colSpan: 7,
              },
              {},
              {},
              {},
              {},
              {},
              {},
            ],
            [
              {
                text: ` ${
                  datos.tipo_promedio == "100" ? "1ro Secundaria" : "7mo Primaria"
                }`,
                alignment: "center",
              },
              {
                text: ` ${
                  datos.tipo_promedio == "100" ? "2do Secundaria" : "8vo Primaria"
                }`,
                alignment: "center",
              },
              {
                text: ` ${
                  datos.tipo_promedio == "100" ? "3ro" : "1ro"
                } Secundaria`,
                alignment: "center",
              },
              {
                text: ` ${
                  datos.tipo_promedio == "100" ? "4to" : "2do"
                } Secundaria`,
                alignment: "center",
              },
              {
                text: ` ${
                  datos.tipo_promedio == "100" ? "5to" : "3ro"
                } Secundaria`,
                alignment: "center",
              },
              {
                text: ` ${
                  datos.tipo_promedio == "100" ? "6to" : "4to"
                } Secundaria`,
                alignment: "center",
              },
              {
                text: "Promedio Final\n(100 puntos)",
                alignment: "center",
                bold: true,
              },
            ],
            [
              {
                text: promedios.nota1,
                alignment: "center",
              },
              {
                text: promedios.nota2,
                alignment: "center",
              },
              {
                text: promedios.nota3,
                alignment: "center",
              },
              {
                text: promedios.nota4,
                alignment: "center",
              },
              {
                text: promedios.nota5,
                alignment: "center",
              },
              {
                text: promedios.nota6,
                alignment: "center",
              },
              {
                text: promedio_final.cien,
                alignment: "center",
                bold: true,
              },
            ],
            [
              {
                text: `SUBSISTEMA DE EDUCACIÓN: ${datos.subsistema}`,
                colSpan: 7,
              },
              {},
              {},
              {},
              {},
              {},
              {},
            ],
          ],
        },
      },
      {
        marginTop: 7,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["20%", "80%"],
          body: [
            [
              {
                text: "RESULTADO DE ADMISIÓN",
                bold: true,
                fillColor: "#dddddd",
                colSpan: 2,
              },
              {},
            ],
            [
              {
                text: `EL/LA POSTULANTE ES:`,
              },
              {
                text: datos.estado_id == 9 ? "ADMITIDO" : "NO ADMITIDO",
                bold: true,
              },
            ],
          ],
        },
      },
      {
        marginTop: 5,
        text: "Declaramos que los datos consignados en el presente formulario son fidedignos y son acordes a lo estipulado en la Convocatoria Pública y su Reglamento del Proceso de Admisión de Postulantes a las ESFM/UA, en señal de aceptación y conformidad firmamos:",
        fontSize: 9,
        alignment: "justify",
      },
      {
        marginTop: 5,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["100%"],
          body: [
            [
              {
                text: "COMISIÓN DE ESPECIALIDAD",
                bold: true,
                fillColor: "#dddddd",
              },
            ],
          ],
        },
      },
      {
        fontSize: 9,
        table: {
          headerRows: 1,
          widths: ["40%", "40%", "20%"],
          body: comision,
        },
      },
      {
        marginTop: 10,
        fontSize: 8,
        text: this.currentDateLiteral(),
        alignment: "right",
      },
      {
        marginTop: 5,
        fontSize: 6.5,
        text: 'De existir omisión y/o falsedad de la información remitida a la DGFM de la/el postulante será de plena responsabilidad de la Comisión Institucional de Especialidad, quienes en su totalidad estarán sujetos a Procesos Administrativos, Penales o Civiles, conforme establece la Ley 1178, Ley No. 004 Anticorrupción, "Marcelo Quiroga Santa Cruz", Resolución Suprema 212414 Reglamento de Faltas y Sanciones, Reglamento del Escalafón, Resolución Ministerial No. 062/2000, Código Penal y otras Normas conexas.',
        alignment: "justify",
      },
    ];
    if((modalidad== "B1" || modalidad== "B4"|| modalidad== "B5") && !esp_con_pa.includes(datos.especialidad_id) ){
      contentBody[4]={};
    }
    if(modalidad== "B2" || modalidad== "B3" || modalidad== "B5"){
      contentBody[3]={};
    }
    return contentBody;
  },
  bodyMbPDF(convocatoria, institucion, datos) {
    const currentDate = new Date().toISOString();
    let contentBody = [
      {
        stack: [
          {
            marginTop: -20,
            fontSize: 6,
            text: `Fecha actual\n${this.formatDate(currentDate)}`,
            alignment: "right",
          },
          {
            fontSize: 14,
            bold: true,
            color: "#212121",
            text: convocatoria.cite,
            alignment: "center",
          },
          {
            fontSize: 12,
            bold: true,
            color: "#424242",
            text: "LISTA DE POSTULANTES INSCRITOS",
            alignment: "center",
          },
          {
            fontSize: 12,
            bold: true,
            color: "#424242",
            text: `MODALIDAD B1, B2, B3 y B4 - ${convocatoria.gestion}`,
            alignment: "center",
          },
          {
            marginTop: 8,
            fontSize: 9,
            columns: [
              {
                width: "12%",
                bold: true,
                text: "Departamento: ",
                style: "header",
              },
              {
                width: "15%",
                text: institucion ? institucion.departamento.descripcion : "",

              },
              {
                width: "9%",
                bold: true,
                text: "ESFM/UA: ",
              },
              {
                width: "64%",
                text: institucion ? institucion.nombre : "",
              },
            ],
          },
        ],
      },
    ];
    let tableContent = {
      marginTop: 5,
      fontSize: 8,
      layout: "lightHorizontalLines",
      table: {
        headerRows: 1,
        widths: ["5%", "33%", "13%", "9%", "42%"],
        body: [
          [
            {
              text: "#",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Apellidos y Nombres",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Cédula Identidad",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Modalidad",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Especialidad",
              bold: true,
              fillColor: "#dddddd",
            },
          ],
        ],
      },
    };
    datos.forEach((item, index) => {
      tableContent.table.body.push([
        index + 1,
        item.a_persona.nombre_completo,
        item.a_persona.cedula_dni,
        item.modalidad.sigla,
        item.especialidad.descripcion,
      ]);
    });
    contentBody.push(tableContent);
    return contentBody;
  },
  bodyButacaPDF(convocatoria, datos, pbreak = null) {
    const codesize = datos.id.toString().length;
    let codigo = "0".repeat(10 - codesize);
    codigo = codigo + datos.id;
    const contentBody = [
      {
        columns: [
          {
            width: "100%",
            stack: [
              {
                fontSize: 13,
                bold: true,
                color: "#212121",
                text: convocatoria.cite,
                alignment: "center",
                marginTop: 2,
              },
              {
                fontSize: 9,
                color: "#212121",
                text: `${convocatoria.descripcion.toUpperCase()} GESTIÓN ${
                  convocatoria.gestion
                }`,
                alignment: "center",
              },
              {
                fontSize: 22,
                bold: true,
                color: "#212121",
                text: "NÚMERO DE BUTACA",
                alignment: "center",
                marginTop: 2,
              },
              {
                fontSize: 38,
                bold: true,
                color: "#212121",
                text: datos.butaca,
                alignment: "center",
              },
            ],
          },
        ],
      },
      {
        marginTop: 8,
        fontSize: 9,
        table: {
          headerRows: 1,
          widths: ["28%", "72%"],
          body: [
            [
              {
                bold: true,
                fillColor: "#dddddd",
                text: "Cédula de Identidad",
              },
              {
                fontSize: 11,
                bold: true,
                text: datos.a_postulante.a_persona.cedula_dni,
              },
            ],
            [
              {
                bold: true,
                fillColor: "#dddddd",
                text: "Departamento",
              },
              datos.institucion.departamento.descripcion,
            ],
            [
              { text: "Especialidad", bold: true, fillColor: "#dddddd" },
              { text: datos.especialidad.descripcion },
            ],
            [
              {
                fontSize: 11,
                bold: true,
                colSpan: 2,
                text: "RECINTO",
                fillColor: "#dddddd",
                alignment: "center",
              },
              {},
            ],
            [
              {
                fontSize: 11,
                colSpan: 2,
                text: datos.sede ? datos.sede.nombre : "SIN RECINTO",
                alignment: "center",
              },
              {},
            ],
          ],
        },
      },
      {
        fontSize: 7.5,
        stack: [
          [
            // {
            //   marginTop: 8,
            //   bold: true,
            //   text: "Implementos de bioseguridad",
            // },
            // {
            //   text: "Cada postulante debe contar con los siguientes implementos personales:",
            // },
            // {
            //   ul: [
            //     "Barbijo",
            //     "Alcohol en spray o alcohol en gel",
            //   ],
            // },
            {
              marginTop: 5,
              text: "Portar: Únicamente su Cédula de Identidad original vigente.",
              bold: true,
            },
          ],
          [
            {
              marginTop: 5,
              bold: true,
              text: "Nota:",
            },
            {
              ul: [
                "En caso de identificarse falsedad material o suplantación de identidad, se remitirá a instancias judiciales competentes",
                {
                  text: "NO SE PERMITIRÁ el ingreso de mochilas, celulares, calculadoras, audífonos, relojes, cámaras u otros dispositivos electrónicos.",
                  bold: true,
                },
                "Queda terminantemente prohibido asistir a la prueba escrita, bajo el efecto de bebidas alcohólicas o estupefacientes.",
                "Queda prohibido causar disturbios que afecten o entorpezcan el normal desarrollo de la Prueba Escrita.",
                "Queda prohibido copiar, hacer copiar o conversar durante el desarrollo de la Prueba Escrita.",
                "Queda prohibido tomar fotografías y/o difundir por cualquier medio de comunicación la Prueba Escrita.",
                "En caso de no entregar la hoja de preguntas y/o la hoja de respuestas de la Prueba Escrita en el tiempo establecido, se procederá a la anulación de su postulación."
              ],
            },
          ],
        ],
      },
      {
        qr: `|ADMISION-${convocatoria.gestion}|CI-${datos.a_postulante.a_persona.cedula_dni}|FN_${datos.a_postulante.a_persona.fecha_nacimiento}|NO-${codigo}|`,
        marginTop: 5,
        foreground: "#212121",
        alignment: "left",
        fit: "100",
        pageBreak: pbreak,
      },
    ];
    return contentBody;
  },
  certifiedApplicationFormBanco(convocatoria, data) {
    const codesize = data.postulante.id.toString().length;
    let codigo = "0".repeat(10 - codesize);
    codigo = codigo + data.postulante.id;
    //const ahead = ;
    let FontSizeF2 = 9
let Form2 = [
  {
    pageBreak: "before",
    stack: [
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: "FORMULARIO N° 2",
        alignment: "right",
        marginTop: 1,
      },
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: "DECLARACIÓN JURADA DE INEXISTENCIA DE",
        alignment: "center",
        marginTop: 1,
      },
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: `PROCESOS ADMINISTRATIVOS Y PENALES`,
        alignment: "center",
      },
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: `(ESFM/UA)`,
        alignment: "center",
      },
    ],
  },
  {
    marginTop: 10,
    fontSize: FontSizeF2,
    layout: "lightHorizontalLines",
    table: {
      widths: ["30%", "30%", "20%", "20%"],
      body: [
        [{},{},{},{}],
        [
          {
            text: "NOMBRES: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.c_persona.nombres, colSpan: 3 },
          {},
          {},
        ],
        [
          {
            text: "APELLIDOS: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: `${data.postulante.c_persona.paterno} ${data.postulante.c_persona.materno}` , colSpan: 3 },
          {},
          {},
        ],
        [
          {
            text: "CÉDULA DE IDENTIDAD: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.c_persona.cedula_dni },
          { text: "RDA: ", bold: true, fillColor: "#dddddd" },
          data.postulante.c_persona.rda,
        ],
        [
          {
            text: "LUGAR DE TRABAJO: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.lugar_trabajo },
          {},
          {}
        ],
        [
          { text: "ESFM/UA: ", bold: true, fillColor: "#dddddd" },
          { text: `${data.postulante.institucion.departamento.descripcion } - ${data.postulante.institucion.nombre }`, colSpan: 3 },
          {},
          {},
        ],
        [
          {
            text: "CARGO: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.cargo.descripcion },
          {},
          {},
          
        ],
       
      ],
    },
  },
  {
    marginTop: 10,
    stack: [
      [
        {
          text: "1.	A la fecha Declaro que: No tengo Procesos Administrativos y Penales con sentencia ejecutoriada. Para tal efecto, autorizo al Ministerio de Educación a verificar en las Instituciones donde presté mis servicios. (señalar las Instituciones donde trabajó los últimos 10 años).",
          alignment: "justify",
          fontSize: FontSizeF2,
        },
      ],
    ],
  },
    {},
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "2.	De existir en mi contra Procesos Administrativos y/o Penales con sentencia ejecutoriada, es de mi conocimiento que la postulación al cargo quedará sin efecto o en caso de resultar seleccionada/o mi persona será destituida en el acto y con ello todos sus efectos, por no emitir información fidedigna,   debiendo asumir las sanciones administrativas y/o penales correspondientes, conforme lo establece la Ley No. 1178 Ley de Administración y Control Gubernamentales (SAFCO), Ley No. 004 Anticorrupción, “Marcelo Quiroga Santa Cruz”, Resolución Suprema 212414 Reglamento de Faltas y Sanciones, Decreto Supremo Nº 04688 del Reglamento del Escalafón Nacional del Servicio de Educación,  Resolución Ministerial 062/2000 Reglamento de la Carrera Administrativa del Servicio de Educación Pública del 17 de febrero del 2000, Código Penal y otras normas conexas vigentes.",
            alignment: "justify",
            fontSize: FontSizeF2,
          },
        ],
      ],
    },
    
    {
      marginTop: 10,
      stack: [
        [
          {
            text: `Yo: ${data.postulante.c_persona.nombre_completo}, con C.I.${data.postulante.c_persona.cedula_dni}, declaro que todos los datos consignados en el presente formulario son verídicos.`,
            alignment: "justify",
            fontSize: FontSizeF2,
          },
        ],
      ],
    },
    {
      columns: [
        {
          width: "100%",
          fontSize: 10,
          color: "#212121",
          text: `_____________________________________\nFIRMA DE LA O EL DECLARANTE\n${data.postulante.institucion.departamento.descripcion }, ${this.formatDate(
            data.postulante.fecha_registro
          )}`,
          alignment: "center",
          marginTop: 65,
        },
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "NOTA: El contenido de la presente declaración es de exclusiva responsabilidad del declarante.",
            alignment: "justify",
            fontSize: FontSizeF2,
          },
        ],
      ],
    },
  ];
  if(data.persona_trabajo != "null" && data.persona_trabajo != null && data.persona_trabajo!==""){
    //let persona_trabajos =data.postulante.persona_trabajo!=="" ? JSON.parse(data.postulante.persona_trabajo):"";
    
    //if(Object.keys(persona_trabajos).length > 0 ){
    if(data.persona_trabajo.length>0){ 
      Form2[3]={
        marginTop: 10,
        fontSize: FontSizeF2,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["10%","20%", "20%","15%", "35%"],
          body: [
            [
              {
                text: "GESTIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "INSTITUCIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "CARGO",
              bold: true,
              fillColor: "#dddddd",},
              {text: "TELÉFONO",
              bold: true,
              fillColor: "#dddddd",},
              {text: "LUGAR Y DIRECCION",
              bold: true,
              fillColor: "#dddddd",},
            ],
          ],
        },
      };
      data.persona_trabajo.forEach(dato=>{
        Form2[3].table.body.push([
          {text:dato.gestion.gestion},
          {text:dato.institucion.toUpperCase()},
          {text:dato.cargo.toUpperCase()},
          {text:dato.telefono.toUpperCase()},
          {text:`${dato.departamento.sigla.toUpperCase()}, ${dato.direccion.toUpperCase()}`},
          ])
        }
      );   
    }
  }

let FontSizeF3= 9
  let Form3 = [
    {
      pageBreak: "before",
      stack: [
        {
          fontSize: 12,
          bold: true,
          color: "#212121",
          text: "FORMULARIO N° 3",
          alignment: "right",
          marginTop: 1,
        },
        {
          fontSize: 12,
          bold: true,
          color: "#212121",
          text: "FORMULARIO DE DECLARACIÓN DE INCOMPATIBILIDAD LABORAL Y CONFLICTO DE INTERESES",
          alignment: "center",
          marginTop: 10,
        },
        {
          fontSize: 12,
          bold: true,
          color: "#212121",
          text: `(ESFM/UA)`,
          alignment: "center",
        },
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "•	Juro que todos los datos declarados en el presente formulario son verídicos. De comprobarse la falsedad de alguno de ellos seré sujeto/a a las sanciones que establece el Marco Legal de la Ley No. 1178 Ley de Administración y Control Gubernamentales (SAFCO), Ley No. 004 Anticorrupción, “Marcelo Quiroga Santa Cruz”, Resolución Suprema 212414 Reglamento de Faltas y Sanciones, Decreto Supremo Nº 04688 del Reglamento del Escalafón Nacional del Servicio de Educación,  Resolución Ministerial 062/2000 Reglamento de la Carrera Administrativa del Servicio de Educación Pública del 17 de febrero del 2000, Código Penal y otras normas conexas vigentes.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "•	Asimismo, autorizo expresamente al Ministerio de Educación, a verificar la información proporcionada y me comprometo en caso de ser requerido, a presentar la documentación que sustente lo declarado.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "•	De presentarse modificaciones posteriores a la presente, me comprometo a declarar, inmediatamente las mismas mediante el llenado y presentación de un nuevo formulario.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "1.	DATOS GENERALES DEL DECLARANTE",
            alignment: "justify",
            fontSize: FontSizeF3,
            bold: true,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      fontSize: FontSizeF3,
      layout: "lightHorizontalLines",
      table: {
        widths: ["30%", "30%", "20%", "20%"],
        body: [
          [{},{},{},{}],
          [
            {
              text: "NOMBRES: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.nombres, colSpan: 3 },
            {},
            {},
          ],
          [
            {
              text: "APELLIDOS: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: `${data.postulante.c_persona.paterno} ${data.postulante.c_persona.materno}`, colSpan: 3 },
            {},
            {},
          ],
          [
            {
              text: "CÉDULA DE IDENTIDAD: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.cedula_dni },
            { text: "RDA: ", bold: true, fillColor: "#dddddd" },
            data.postulante.c_persona.rda,
          ],
          [
            {
              text: "DOMICILIO: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.direccion, },
            {},
            {}
          ],
          [
            {
              text: "NRO. DE CELULAR: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.celular },
            {},
            {},
            
          ],
          [
            { text: "ESFM/UA: ", bold: true, fillColor: "#dddddd" },
            { text: `${data.postulante.institucion.departamento.descripcion } - ${data.postulante.institucion.nombre }`, colSpan: 3 },
            {},
            {},
          ],
          [
            { text: "CARGO: ", bold: true, fillColor: "#dddddd" },
            { text: data.postulante.cargo.descripcion, colSpan: 3 },
            {},
            {},
          ],
        ],
      },
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "2.	DECLARACIÓN DE INCOMPATIBILIDAD",
            alignment: "justify",
            fontSize: FontSizeF3,
            bold: true,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "Declaro a mi leal saber y entender que:",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.1. ", bold:true}, {text:data.datos_incompatibilidad.interes_personal?"SI":"NO", bold:true}, " Tengo intereses de carácter personal, negocios, contratos privados, comerciales, financieros, económicos u otros directos o indirectos con el desempeño de mi función pública y/o con el Ministerio de Educación"
            ],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.2. ", bold:true},{text:data.datos_incompatibilidad.tiene_cargo_otra_institucion?"SI":"NO", bold:true}, " Ejerzo más de una actividad como docente u otro cargo en otras instituciones públicas o privadas (si la respuesta es positiva responda el numeral 2.2.1 y 2.2.2)"],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.2.1 ", bold:true},"De existir incompatibilidad horaria entre esta actividad y aquellas que se deriven de mis nuevas funciones, me comprometo a respetar lo estipulado (Dedicación Exclusiva y a tiempo completo) de acuerdo al Compendio de Normativa para las ESFM/UA"],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
    //tabla 11
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.2.2. ", bold:true},{text:data.datos_incompatibilidad.otra_remuneracion?"SI":"NO", bold:true}, " Percibo remuneración salarial como servidor público, consultor de  línea, consultor por producto u otra actividad mayor o igual al del Sr. Presidente del Estado Plurinacional de Bolivia. Los montos excedentes a la remuneración máxima establecida para el sector público, constituyen deudas imprescriptibles por daño económico al Estado. Artículo 12 del Decreto Supremo 4434"],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      //tabla 13
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.3.	", bold:true},{text:data.datos_incompatibilidad.tiene_parentesco?"SI":"NO", bold:true}, " Tengo miembro (s) de mi familia hasta el 2do grado de consanguinidad y 2do. Grado de afinidad desempeñando cargos y/o funciones en la ESFM/UA con su inmediato superior."],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "2.4	Relaciones de Parentesco: ",
            alignment: "justify",
            fontSize: FontSizeF3,
            bold:true,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "Registrar sólo los parientes con vida, en el siguiente orden: padre, madre, abuelos, hijos, nietos, hermanos, conyugue, suegros, cuñados, yernos, y nueras (Declárelos siempre que sean mayores de 16 años).",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {//tabla 17
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.5.	", bold:true},{text:data.datos_incompatibilidad.tiene_renta?"SI":"NO", bold:true}, " Recibo del Estado, renta(s) correspondiente(s) a jubilación, subsidios y otros parecidos. (Continúe si la respuesta es positiva)."],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text:data.datos_incompatibilidad.institucion_renta==""?"": "Estos ingresos, corresponden a mi permanencia en (nombre de la institución donde trabajó):",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {//EMPRESA DONDE TRABAJÓ
      //marginTop: 10,
      marginLeft: 20,
      stack: [
        [
          {
            text: data.datos_incompatibilidad.institucion_renta.toUpperCase(),
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: data.datos_incompatibilidad.cargo_renta==""?"":"Donde desarrollé actividades en el cargo de:",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginLeft: 20,
      stack: [
        [
          {
            text: data.datos_incompatibilidad.cargo_renta.toUpperCase(),
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "Al considerar lo anterior como un conflicto de interés, corresponde a mi persona a renunciar en el acto, a estos beneficios; así mismo, me comprometo a realizar todos los trámites que se originen de esta decisión.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      columns: [
        {
          width: "100%",
          fontSize: 10,
          color: "#212121",
          text: `_____________________________________\nFIRMA DE LA O EL DECLARANTE\n ${data.postulante.institucion.departamento.descripcion }, ${this.formatDate(
            data.postulante.fecha_registro
          )}`,
          alignment: "center",
          marginTop: 65,
        },
      ],
    },
  ]
  if(data.datos_incompatibilidad.detalle_cargo_otra_institucion != "null" && data.datos_incompatibilidad.detalle_cargo_otra_institucion != null && data.datos_incompatibilidad.detalle_cargo_otra_institucion!==""){
    let detalle_cargo_otra_institucion =data.datos_incompatibilidad.detalle_cargo_otra_institucion!=="" ? JSON.parse(data.datos_incompatibilidad.detalle_cargo_otra_institucion):"";
    
    if(Object.keys(detalle_cargo_otra_institucion).length > 0 ){
      Form3[11]={
        marginTop: 10,
        fontSize: FontSizeF3,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["50%","25%", "25%"],
          body: [
            [
              {
                text: "NOMBRE DE LA INSTITUCIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "TRABAJA DESDE (FECHA)",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "HORARIO",
              bold: true,
              fillColor: "#dddddd",},
            ],
          ],
        },
      };
      detalle_cargo_otra_institucion.forEach(dato=>{
        Form3[11].table.body.push([
          {text:dato.institucion.toUpperCase()},
          {text:dato.fecha},
          {text:dato.horario},
          ])
        }
      );   
    }
  }
  if(data.datos_incompatibilidad.detalle_otra_remuneracion != "null" && data.datos_incompatibilidad.detalle_otra_remuneracion != null && data.datos_incompatibilidad.detalle_otra_remuneracion!==""){
    let detalle_otra_remuneracion =data.datos_incompatibilidad.detalle_otra_remuneracion!=="" ? JSON.parse(data.datos_incompatibilidad.detalle_otra_remuneracion):"";
    
    if(Object.keys(detalle_otra_remuneracion).length > 0 ){
      Form3[13]={
        marginTop: 10,
        fontSize: FontSizeF3,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["35%","33%", "17%", "15%"],
          body: [
            [
              {
                text: "NOMBRE DE LA INSTITUCIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "CARGO",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "FECHA DE INGRESO",
              bold: true,
              fillColor: "#dddddd",},
              {text: "TOTAL GANADO",
              bold: true,
              fillColor: "#dddddd",},
            ],
          ],
        },
      };
      detalle_otra_remuneracion.forEach(dato=>{
        Form3[13].table.body.push([
          {text:dato.institucion.toUpperCase()},
          {text:dato.cargo.toUpperCase()},
          {text:dato.fecha_ingreso},
          {text:dato.total_ganado},
          ])
        }
      );   
    }
  }

  if(data.parientes != "null" && data.parientes != null && data.parientes!==""){
    //let persona_trabajos =data.postulante.persona_trabajo!=="" ? JSON.parse(data.postulante.persona_trabajo):"";
    
    //if(Object.keys(persona_trabajos).length > 0 ){
    if(data.parientes.length>0){ 
      Form3[17]={
        marginTop: 10,
        fontSize: FontSizeF2,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["25%", "25%","25%", "25%"],
          body: [
            [
              {
                text: "Parentesco",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "Apellido Paterno",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "Apellido Materno",
              bold: true,
              fillColor: "#dddddd",},
              {text: "Nombres",
              bold: true,
              fillColor: "#dddddd",},
            
            ],
          ],
        },
      };
      data.parientes.forEach(dato=>{
        Form3[17].table.body.push([
          {text:dato.tipo_parentesco.descripcion},
          {text:dato.apellido_paterno.toUpperCase()},
          {text:dato.apellido_materno.toUpperCase()},
          {text:dato.nombres.toUpperCase()},
      
          ])
        }
      );   
    }
  }
  

    let contentbody = [
      {
       stack: [
          {
            fontSize: 12,
            bold: true,
            color: "#212121",
            text: "FORMULARIO N° 1",
            alignment: "right",
            marginTop: 1,
          },
          {
            marginTop: 10,
            fontSize: 15,
            bold: true,
            color: "#212121",
            text: "FORMULARIO DE REGISTRO",
            alignment: "center",
          },
          {
            fontSize: 13,
            bold: true,
            color: "#212121",
            text: convocatoria.cite,
            alignment: "center",
            marginTop: 2,
          },
          {
            fontSize: 10.5,
            color: "#212121",
            text: convocatoria.descripcion.toUpperCase(),
            alignment: "center",
          },
          {
            fontSize: 9,
            bold: true,
            color: "#212121",
            text: `Fecha de Registro: ${this.formatDate(
              data.postulante.fecha_registro
            )}`,
            alignment: "center",
            marginTop: 4,
          },
        ],
      },
      // {
      //   columns: [
      //     {
      //       width: "100%",
      //       stack: [
      //         {
      //           fontSize: 10,
      //           bold: true,
      //           color: "#424242",
      //           text: "VICEMINISTERIO DE EDUCACIÓN SUPERIOR DE FORMACIÓN PROFESIONAL",
      //           alignment: "center",
      //         },
      //         {
      //           fontSize: 10,
      //           bold: true,
      //           color: "#424242",
      //           text: "DIRECCIÓN GENERAL DE FORMACIÓN DE MAESTROS",
      //           alignment: "center",
      //         },
              
      //       ],
      //     },
      //   ],
      // },
      {
        marginTop: 8,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["21%", "79%"],
          body: [
            [
              {
                text: "DATOS PERSONALES",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              {
                text: "Apellidos y Nombres: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.postulante.c_persona.nombre_completo,
            ],
            [
              {
                text: "Cédula de Identidad: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.postulante.c_persona.cedula_dni,
            ],
            [
              {
                text: "RDA: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.postulante.c_persona.rda ? data.postulante.c_persona.rda : "",
            ],
            [
              {
                text: "Fecha de Nacimiento: ",
                bold: true,
                fillColor: "#dddddd",
              },
              this.formatDate(data.postulante.c_persona.fecha_nacimiento),
            ],
            [
              { text: "Género: ", bold: true, fillColor: "#dddddd" },
              data.postulante.c_persona.genero.descripcion,
            ],
            [
              {
                text: "Teléfono/Celular: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.postulante.c_persona.celular },
            ],
            [
              {
                text: "Correo Electónico: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.postulante.c_persona.correo_electronico },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["20%", "80%"],
          body: [
            [
              {
                text: "DATOS DE REGISTRO",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              { text: "ESFM/UA: ", bold: true, fillColor: "#dddddd" },
              {
                text: `${data.postulante.institucion.departamento.descripcion} - ${data.postulante.institucion.nombre}`,
              },
            ],
            [
              {
                text: "Cargo: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.postulante.cargo.descripcion },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["20%", "80%"],
          body: [
            [
              {
                text: "COMPROMISO",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              { text: "Dedicación exclusiva de trabajo a tiempo completo en la ESFM/UA.", 
             
              colSpan: 2, },
              {
                
              },
            ],
            [
              { text: "Trabajo en equipo con ética, transparencia y resultados de calidad.", 
              
              colSpan: 2,},
              {
                
              },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["100%"],
          body: [
            [
              {
                text: "DECLARACIÓN JURADA",
                bold: true,
                fillColor: "#dddddd",
              },
            ],
            [{ text: "" }],
          ],
        },
      },
      {
        stack: [
          [
            {
              text: "Declaro bajo juramento, que los datos expuestos en el presente formulario son fehacientes y fidedignos por lo que autorizo que los representantes del Ministerio de Educación puedan verificar la documentación concerniente a mi persona. En caso de comprobarse falsedad u omisión en los datos presentados, asumo las consecuencias y sanciones que de mi acción se deriven y tengo conocimiento que seré descalificada/o en cualquier etapa del proceso, así mismo, asumiré las sanciones administrativas y/o penales correspondientes, conforme establece la normativa vigente.",
              alignment: "justify",
              fontSize: 8.5,
            },
          ],
          [
            {
              marginTop: 3,
              text: "De igual manera, declaro que no cuento con ninguna causal de impedimento o incompatibilidad para participar del presente registro, en caso de acceder al cargo me comprometo a cumplir con todo lo exigido y desempeñar mis funciones asignadas con dedicación exclusiva a tiempo completo.",
              alignment: "justify",
              fontSize: 8.5,
            },
          ],
        ],
      },
      {
        columns: [
          {
            qr: `|REGISTRO-${convocatoria.gestion}|CI-${data.postulante.c_persona.cedula_dni}|FN_${data.postulante.c_persona.fecha_nacimiento}|NO-${codigo}|`,
            marginTop: 10,
            foreground: "#212121",
            fit: "100",
          },
          {
            width: "80%",
            fontSize: 10,
            color: "#212121",
            text: "_______________________________\nFIRMA",
            alignment: "center",
            marginTop: 65,
          },
        ],
      },
    ];
    contentbody.push(Form2);
    contentbody.push(Form3);
    const docDefinition = {
      pageSize: "LETTER",
      pageMargins: [60, 75, 60, 50],
      header: this.setting("left").header,
      footer: this.setting().footer,
      content: contentbody,
    };

    return pdfMake.createPdf(docDefinition).open();
  },
    certifiedApplicationForm(convocatoria, data) {
    const codesize = data.postulante.id.toString().length;
    let codigo = "0".repeat(10 - codesize);
    codigo = codigo + data.postulante.id;
    //const ahead = ;
    let FontSizeF2 = 9
let Form2 = [
  {
    pageBreak: "before",
    stack: [
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: "FORMULARIO N° 2",
        alignment: "right",
        marginTop: 1,
      },
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: "DECLARACIÓN JURADA DE INEXISTENCIA DE",
        alignment: "center",
        marginTop: 1,
      },
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: `PROCESOS ADMINISTRATIVOS Y PENALES`,
        alignment: "center",
      },
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: `(ESFM/UA)`,
        alignment: "center",
      },
    ],
  },
  {
    marginTop: 10,
    fontSize: FontSizeF2,
    layout: "lightHorizontalLines",
    table: {
      widths: ["30%", "30%", "20%", "20%"],
      body: [
        [{},{},{},{}],
        [
          {
            text: "NOMBRES: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.c_persona.nombres, colSpan: 3 },
          {},
          {},
        ],
        [
          {
            text: "APELLIDOS: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: `${data.postulante.c_persona.paterno} ${data.postulante.c_persona.materno}` , colSpan: 3 },
          {},
          {},
        ],
        [
          {
            text: "CÉDULA DE IDENTIDAD: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.c_persona.cedula_dni },
          { text: "RDA: ", bold: true, fillColor: "#dddddd" },
          data.postulante.c_persona.rda,
        ],
        [
          {
            text: "LUGAR DE TRABAJO: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.lugar_trabajo },
          {},
          {}
        ],
        [
          { text: "ESFM/UA A LA QUE POSTULA: ", bold: true, fillColor: "#dddddd" },
          { text: `${data.postulante.institucion.departamento.descripcion } - ${data.postulante.institucion.nombre }`, colSpan: 3 },
          {},
          {},
        ],
        [
          {
            text: "CARGO: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.cargo.descripcion },
          {},
          {},
          
        ],
       
      ],
    },
  },
  {
    marginTop: 10,
    stack: [
      [
        {
          text: "1.	A la fecha Declaro que: No tengo Procesos Administrativos y Penales con sentencia ejecutoriada. Para tal efecto, autorizo al Ministerio de Educación a verificar en las Instituciones donde presté mis servicios. (señalar las Instituciones donde trabajó los últimos 10 años).",
          alignment: "justify",
          fontSize: FontSizeF2,
        },
      ],
    ],
  },
    {},
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "2.	De existir en mi contra Procesos Administrativos y/o Penales con sentencia ejecutoriada, es de mi conocimiento que la postulación al cargo quedará sin efecto o en caso de resultar seleccionada/o mi persona será destituida en el acto y con ello todos sus efectos, por no emitir información fidedigna,   debiendo asumir las sanciones administrativas y/o penales correspondientes, conforme lo establece la Ley No. 1178 Ley de Administración y Control Gubernamentales (SAFCO), Ley No. 004 Anticorrupción, “Marcelo Quiroga Santa Cruz”, Resolución Suprema 212414 Reglamento de Faltas y Sanciones, Decreto Supremo Nº 04688 del Reglamento del Escalafón Nacional del Servicio de Educación,  Resolución Ministerial 062/2000 Reglamento de la Carrera Administrativa del Servicio de Educación Pública del 17 de febrero del 2000, Código Penal y otras normas conexas vigentes.",
            alignment: "justify",
            fontSize: FontSizeF2,
          },
        ],
      ],
    },
    
    {
      marginTop: 10,
      stack: [
        [
          {
            text: `Yo: ${data.postulante.c_persona.nombre_completo}, con C.I.${data.postulante.c_persona.cedula_dni}, declaro que todos los datos consignados en el presente formulario son verídicos.`,
            alignment: "justify",
            fontSize: FontSizeF2,
          },
        ],
      ],
    },
    {
      columns: [
        {
          width: "100%",
          fontSize: 10,
          color: "#212121",
          text: `_____________________________________\nFIRMA DE LA O EL DECLARANTE\n${data.postulante.institucion.departamento.descripcion }, ${this.formatDate(
            data.postulante.fecha_registro
          )}`,
          alignment: "center",
          marginTop: 65,
        },
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "NOTA: El contenido de la presente declaración es de exclusiva responsabilidad del declarante.",
            alignment: "justify",
            fontSize: FontSizeF2,
          },
        ],
      ],
    },
  ];
  if(data.persona_trabajo != "null" && data.persona_trabajo != null && data.persona_trabajo!==""){
    //let persona_trabajos =data.postulante.persona_trabajo!=="" ? JSON.parse(data.postulante.persona_trabajo):"";
    
    //if(Object.keys(persona_trabajos).length > 0 ){
    if(data.persona_trabajo.length>0){ 
      Form2[3]={
        marginTop: 10,
        fontSize: FontSizeF2,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["10%","20%", "20%","15%", "35%"],
          body: [
            [
              {
                text: "GESTIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "INSTITUCIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "CARGO",
              bold: true,
              fillColor: "#dddddd",},
              {text: "TELÉFONO",
              bold: true,
              fillColor: "#dddddd",},
              {text: "LUGAR Y DIRECCION",
              bold: true,
              fillColor: "#dddddd",},
            ],
          ],
        },
      };
      data.persona_trabajo.forEach(dato=>{
        Form2[3].table.body.push([
          {text:dato.gestion.gestion},
          {text:dato.institucion.toUpperCase()},
          {text:dato.cargo.toUpperCase()},
          {text:dato.telefono.toUpperCase()},
          {text:`${dato.departamento.sigla.toUpperCase()}, ${dato.direccion.toUpperCase()}`},
          ])
        }
      );   
    }
  }

let FontSizeF3= 9
  let Form3 = [
    {
      pageBreak: "before",
      stack: [
        {
          fontSize: 12,
          bold: true,
          color: "#212121",
          text: "FORMULARIO N° 2",
          alignment: "right",
          marginTop: 1,
        },
        {
          fontSize: 12,
          bold: true,
          color: "#212121",
          text: "DECLARACIÓN DE INEXISTENCIA DE INCOMPATIBILIDAD LABORAL",
          alignment: "center",
          marginTop: 10,
        },
        {
          fontSize: 12,
          bold: true,
          color: "#212121",
          text: convocatoria.cite,
          alignment: "center",
        },
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "•	Juro que todos los datos declarados en el presente formulario son verídicos. De comprobarse la falsedad de alguno de ellos seré sujeto/a a las sanciones que establece el Marco Legal de la Ley No. 1178 Ley de Administración y Control Gubernamentales (SAFCO), Ley No. 004 Anticorrupción, “Marcelo Quiroga Santa Cruz”, Resolución Suprema 212414 Reglamento de Faltas y Sanciones, Decreto Supremo Nº 04688 del Reglamento del Escalafón Nacional del Servicio de Educación,  Resolución Ministerial 062/2000 Reglamento de la Carrera Administrativa del Servicio de Educación Pública del 17 de febrero del 2000, Código Penal y otras normas conexas vigentes.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "•	Asimismo, autorizo expresamente al Ministerio de Educación, a verificar la información proporcionada y me comprometo en caso de ser requerido, a presentar la documentación que sustente lo declarado.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "•	De presentarse modificaciones posteriores a la presente, me comprometo a declarar, inmediatamente las mismas mediante el llenado y presentación de un nuevo formulario.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "1.	DATOS GENERALES DEL DECLARANTE",
            alignment: "justify",
            fontSize: FontSizeF3,
            bold: true,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      fontSize: FontSizeF3,
      layout: "lightHorizontalLines",
      table: {
        widths: ["30%", "30%", "20%", "20%"],
        body: [
          [{},{},{},{}],
          [
            {
              text: "NOMBRES: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.nombres, colSpan: 3 },
            {},
            {},
          ],
          [
            {
              text: "APELLIDOS: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: `${data.postulante.c_persona.paterno} ${data.postulante.c_persona.materno}`, colSpan: 3 },
            {},
            {},
          ],
          [
            {
              text: "CÉDULA DE IDENTIDAD: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.cedula_dni },
            { text: "RDA: ", bold: true, fillColor: "#dddddd" },
            data.postulante.c_persona.rda,
          ],
          [
            {
              text: "DOMICILIO: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.direccion, },
            {},
            {}
          ],
          [
            {
              text: "NRO. DE CELULAR: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.celular },
            {},
            {},
            
          ],
          [
            { text: "ESFM/UA A LA QUE POSTULA: ", bold: true, fillColor: "#dddddd" },
            { text: `${data.postulante.institucion.departamento.descripcion } - ${data.postulante.institucion.nombre }`, colSpan: 3 },
            {},
            {},
          ],
          [
            { text: "CARGO: ", bold: true, fillColor: "#dddddd" },
            { text: data.postulante.cargo.descripcion, colSpan: 3 },
            {},
            {},
          ],
        ],
      },
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "2.	DECLARACIÓN DE INCOMPATIBILIDAD",
            alignment: "justify",
            fontSize: FontSizeF3,
            bold: true,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "Declaro a mi leal saber y entender que:",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.1. ", bold:true}, {text:data.datos_incompatibilidad.interes_personal?"SI":"NO", bold:true}, " Tengo intereses de carácter personal, negocios, contratos privados, comerciales, financieros, económicos u otros directos o indirectos con el desempeño de mi función pública y/o con el Ministerio de Educación"
            ],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.2. ", bold:true},{text:data.datos_incompatibilidad.tiene_cargo_otra_institucion?"SI":"NO", bold:true}, " Ejerzo más de una actividad como docente u otro cargo en otras instituciones públicas o privadas (si la respuesta es positiva responda el numeral 2.2.1 y 2.2.2)"],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.2.1 ", bold:true},"De existir incompatibilidad horaria entre esta actividad y aquellas que se deriven de mis nuevas funciones, me comprometo a respetar lo estipulado (Dedicación Exclusiva y a tiempo completo) de acuerdo al Compendio de Normativa para las ESFM/UA"],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
    //tabla 11
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.2.2. ", bold:true},{text:data.datos_incompatibilidad.otra_remuneracion?"SI":"NO", bold:true}, " Percibo remuneración salarial como servidor público, consultor de  línea, consultor por producto u otra actividad mayor o igual al del Sr. Presidente del Estado Plurinacional de Bolivia. Los montos excedentes a la remuneración máxima establecida para el sector público, constituyen deudas imprescriptibles por daño económico al Estado. Artículo 12 del Decreto Supremo 4434"],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      //tabla 13
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.3.	", bold:true},{text:data.datos_incompatibilidad.tiene_parentesco?"SI":"NO", bold:true}, " Tengo miembro(s) de mi familia hasta el 4to grado de consanguinidad y 2do. Grado de afinidad desempeñando cargos y/o funciones en la ESFM/UA con su inmediato superior y/o personal de su dependencia."],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "2.4	Relaciones de Parentesco: ",
            alignment: "justify",
            fontSize: FontSizeF3,
            bold:true,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "Registrar sólo los parientes con vida, en el siguiente orden: padre, madre, abuelos, hijos, nietos, hermanos, conyugue, suegros, cuñados, yernos, y nueras (Declárelos siempre que sean mayores de 16 años).",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {//tabla 17
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.5.	", bold:true},{text:data.datos_incompatibilidad.tiene_renta?"SI":"NO", bold:true}, " Recibo del Estado, renta(s) correspondiente(s) a jubilación, subsidios y otros parecidos. (Continúe si la respuesta es positiva)."],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text:data.datos_incompatibilidad.institucion_renta==""?"": "Estos ingresos, corresponden a mi permanencia en (nombre de la institución donde trabajó):",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {//EMPRESA DONDE TRABAJÓ
      //marginTop: 10,
      marginLeft: 20,
      stack: [
        [
          {
            text: data.datos_incompatibilidad.institucion_renta.toUpperCase(),
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: data.datos_incompatibilidad.cargo_renta==""?"":"Donde desarrollé actividades en el cargo de:",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginLeft: 20,
      stack: [
        [
          {
            text: data.datos_incompatibilidad.cargo_renta.toUpperCase(),
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "Al considerar lo anterior como un conflicto de interés, corresponde a mi persona a renunciar en el acto, a estos beneficios; así mismo, me comprometo a realizar todos los trámites que se originen de esta decisión.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      columns: [
        {
          width: "100%",
          fontSize: 10,
          color: "#212121",
          text: `_____________________________________\nFIRMA DE LA O EL DECLARANTE\n ${data.postulante.institucion.departamento.descripcion }, ${this.formatDate(
            data.postulante.fecha_registro
          )}`,
          alignment: "center",
          marginTop: 65,
        },
      ],
    },
  ]
  if(data.datos_incompatibilidad.detalle_cargo_otra_institucion != "null" && data.datos_incompatibilidad.detalle_cargo_otra_institucion != null && data.datos_incompatibilidad.detalle_cargo_otra_institucion!==""){
    let detalle_cargo_otra_institucion =data.datos_incompatibilidad.detalle_cargo_otra_institucion!=="" ? JSON.parse(data.datos_incompatibilidad.detalle_cargo_otra_institucion):"";
    
    if(Object.keys(detalle_cargo_otra_institucion).length > 0 ){
      Form3[11]={
        marginTop: 10,
        fontSize: FontSizeF3,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["50%","25%", "25%"],
          body: [
            [
              {
                text: "NOMBRE DE LA INSTITUCIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "TRABAJA DESDE (FECHA)",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "HORARIO",
              bold: true,
              fillColor: "#dddddd",},
            ],
          ],
        },
      };
      detalle_cargo_otra_institucion.forEach(dato=>{
        Form3[11].table.body.push([
          {text:dato.institucion.toUpperCase()},
          {text:dato.fecha},
          {text:dato.horario},
          ])
        }
      );   
    }
  }
  if(data.datos_incompatibilidad.detalle_otra_remuneracion != "null" && data.datos_incompatibilidad.detalle_otra_remuneracion != null && data.datos_incompatibilidad.detalle_otra_remuneracion!==""){
    let detalle_otra_remuneracion =data.datos_incompatibilidad.detalle_otra_remuneracion!=="" ? JSON.parse(data.datos_incompatibilidad.detalle_otra_remuneracion):"";
    
    if(Object.keys(detalle_otra_remuneracion).length > 0 ){
      Form3[13]={
        marginTop: 10,
        fontSize: FontSizeF3,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["35%","33%", "17%", "15%"],
          body: [
            [
              {
                text: "NOMBRE DE LA INSTITUCIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "CARGO",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "FECHA DE INGRESO",
              bold: true,
              fillColor: "#dddddd",},
              {text: "TOTAL GANADO",
              bold: true,
              fillColor: "#dddddd",},
            ],
          ],
        },
      };
      detalle_otra_remuneracion.forEach(dato=>{
        Form3[13].table.body.push([
          {text:dato.institucion.toUpperCase()},
          {text:dato.cargo.toUpperCase()},
          {text:dato.fecha_ingreso},
          {text:dato.total_ganado},
          ])
        }
      );   
    }
  }

  if(data.parientes != "null" && data.parientes != null && data.parientes!==""){
    //let persona_trabajos =data.postulante.persona_trabajo!=="" ? JSON.parse(data.postulante.persona_trabajo):"";
    
    //if(Object.keys(persona_trabajos).length > 0 ){
    if(data.parientes.length>0){ 
      Form3[17]={
        marginTop: 10,
        fontSize: FontSizeF2,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["25%", "25%","25%", "25%"],
          body: [
            [
              {
                text: "Parentesco",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "Apellido Paterno",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "Apellido Materno",
              bold: true,
              fillColor: "#dddddd",},
              {text: "Nombres",
              bold: true,
              fillColor: "#dddddd",},
            
            ],
          ],
        },
      };
      data.parientes.forEach(dato=>{
        Form3[17].table.body.push([
          {text:dato.tipo_parentesco.descripcion},
          {text:dato.apellido_paterno.toUpperCase()},
          {text:dato.apellido_materno.toUpperCase()},
          {text:dato.nombres.toUpperCase()},
      
          ])
        }
      );   
    }
  }
  

    let contentbody = [
      {
       stack: [
          {
            fontSize: 12,
            bold: true,
            color: "#212121",
            text: "FORMULARIO N° 1",
            alignment: "right",
            marginTop: 1,
          },
          {
            marginTop: 10,
            fontSize: 15,
            bold: true,
            color: "#212121",
            text: "FORMULARIO DE POSTULACIÓN",
            alignment: "center",
          },
          {
            fontSize: 13,
            bold: true,
            color: "#212121",
            text: convocatoria.cite,
            alignment: "center",
            marginTop: 2,
          },
          {
            fontSize: 10.5,
            color: "#212121",
            text: convocatoria.descripcion.toUpperCase(),
            alignment: "center",
          },
          {
            fontSize: 9,
            bold: true,
            color: "#212121",
            text: `Fecha de Postulación: ${this.formatDate(
              data.postulante.fecha_registro
            )}`,
            alignment: "center",
            marginTop: 4,
          },
        ],
      },
      // {
      //   columns: [
      //     {
      //       width: "100%",
      //       stack: [
      //         {
      //           fontSize: 10,
      //           bold: true,
      //           color: "#424242",
      //           text: "VICEMINISTERIO DE EDUCACIÓN SUPERIOR DE FORMACIÓN PROFESIONAL",
      //           alignment: "center",
      //         },
      //         {
      //           fontSize: 10,
      //           bold: true,
      //           color: "#424242",
      //           text: "DIRECCIÓN GENERAL DE FORMACIÓN DE MAESTROS",
      //           alignment: "center",
      //         },
              
      //       ],
      //     },
      //   ],
      // },
      {
        marginTop: 8,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["21%", "79%"],
          body: [
            [
              {
                text: "DATOS PERSONALES",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              {
                text: "Apellidos y Nombres: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.postulante.c_persona.nombre_completo,
            ],
            [
              {
                text: "Cédula de Identidad: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.postulante.c_persona.cedula_dni,
            ],
            [
              {
                text: "RDA: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.postulante.c_persona.rda ? data.postulante.c_persona.rda : "",
            ],
            [
              {
                text: "Fecha de Nacimiento: ",
                bold: true,
                fillColor: "#dddddd",
              },
              this.formatDate(data.postulante.c_persona.fecha_nacimiento),
            ],
            [
              { text: "Genero: ", bold: true, fillColor: "#dddddd" },
              data.postulante.c_persona.genero.descripcion,
            ],
            [
              {
                text: "Teléfono/Celular: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.postulante.c_persona.celular },
            ],
            [
              {
                text: "Correo Electónico: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.postulante.c_persona.correo_electronico },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["20%", "80%"],
          body: [
            [
              {
                text: "DATOS DE POSTULACIÓN",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              { text: "ESFM/UA: ", bold: true, fillColor: "#dddddd" },
              {
                text: `${data.postulante.institucion.departamento.descripcion} - ${data.postulante.institucion.nombre}`,
              },
            ],
            [
              {
                text: "Cargo: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.postulante.cargo.descripcion },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["20%", "80%"],
          body: [
            [
              {
                text: "COMPROMISO",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              { text: "Dedicación exclusiva de trabajo a tiempo completo en la ESFM/UA.", 
             
              colSpan: 2, },
              {
                
              },
            ],
            [
              { text: "Trabajo en equipo con ética, transparencia y resultados de calidad.", 
              
              colSpan: 2,},
              {
                
              },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["100%"],
          body: [
            [
              {
                text: "DECLARACIÓN JURADA",
                bold: true,
                fillColor: "#dddddd",
              },
            ],
            [{ text: "" }],
          ],
        },
      },
      {
        stack: [
          [
            {
              text: "Declaro bajo juramento, que los datos expuestos en el presente formulario son fehacientes y fidedignos por lo que autorizo que los representantes del Ministerio de Educación puedan verificar la documentación concerniente a mi persona. En caso de comprobarse falsedad u omisión en los datos presentados o en la documentación adjunta asumo las consecuencias y sanciones que de mi acción se deriven y tengo conocimiento que seré descalificada/o en cualquier etapa del proceso de Compulsa de Méritos Profesionales, así mismo, asumire las sanciones administrativas y/o penales correspondientes, conforme establece la normativa vigente.",
              alignment: "justify",
              fontSize: 8.5,
            },
          ],
          [
            {
              marginTop: 3,
              text: "De igual manera, declaro que no cuento con ninguna causal de impedimento o incompatibilidad para participar de la presente Convocatoria Pública, en caso de acceder al cargo me comprometo a cumplir con todo lo exigido en la convocatoria y desempeñar mis funciones asignadas con dedicación exclusiva a tiempo completo.",
              alignment: "justify",
              fontSize: 8.5,
            },
          ],
          [
            {
              marginTop: 3,
              text: "Asimismo, declaro NO haberme postulado a más de una Escuela Superior de Formación de Maestras y Maestros y/o Unidad Académica, cargo y/o especialidad, siendo de manera automática mi descalificación del proceso de Compulsa si se verifica lo contrario.",
              alignment: "justify",
              fontSize: 8.5,
            },
          ],
        ],
      },
      {
        columns: [
          {
            qr: `|COMPULSA-${convocatoria.gestion}|CI-${data.postulante.c_persona.cedula_dni}|FN_${data.postulante.c_persona.fecha_nacimiento}|NO-${codigo}|`,
            marginTop: 10,
            foreground: "#212121",
            fit: "100",
          },
          {
            width: "80%",
            fontSize: 10,
            color: "#212121",
            text: "_______________________________\nFIRMA DEL POSTULANTE",
            alignment: "center",
            marginTop: 65,
          },
        ],
      },
    ];
   // contentbody.push(Form2);
    contentbody.push(Form3);
    const docDefinition = {
      pageSize: "LETTER",
      pageMargins: [60, 85, 60, 50],
      header: this.setting("left").header,
      footer: this.setting().footer,
      content: contentbody,
    };

    return pdfMake.createPdf(docDefinition).open();
  },
  certifiedApplicationFormUP(convocatoria, data) {
    const codesize = data.postulante.id.toString().length;
    let codigo = "0".repeat(10 - codesize);
    codigo = codigo + data.postulante.id;
    //const ahead = ;
    let FontSizeF2 = 9
let Form2 = [
  {
    pageBreak: "before",
    stack: [
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: "FORMULARIO N° 2",
        alignment: "right",
        marginTop: 1,
      },
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: "DECLARACIÓN JURADA DE INEXISTENCIA DE",
        alignment: "center",
        marginTop: 1,
      },
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: `PROCESOS ADMINISTRATIVOS Y PENALES`,
        alignment: "center",
      },
      {
        fontSize: 12,
        bold: true,
        color: "#212121",
        text: `(Universidad Pedagógica)`,
        alignment: "center",
      },
    ],
  },
  {
    marginTop: 10,
    fontSize: FontSizeF2,
    layout: "lightHorizontalLines",
    table: {
      widths: ["30%", "30%", "20%", "20%"],
      body: [
        [{},{},{},{}],
        [
          {
            text: "NOMBRES: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.c_persona.nombres, colSpan: 3 },
          {},
          {},
        ],
        [
          {
            text: "APELLIDOS: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: `${data.postulante.c_persona.paterno} ${data.postulante.c_persona.materno}` , colSpan: 3 },
          {},
          {},
        ],
        [
          {
            text: "CÉDULA DE IDENTIDAD: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.c_persona.cedula_dni },
          { text: "RDA: ", bold: true, fillColor: "#dddddd" },
          data.postulante.c_persona.rda,
        ],
        [
          {
            text: "LUGAR DE TRABAJO: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.postulante.lugar_trabajo },
          {},
          {}
        ],
        [
          { text: "CARGO AL QUE POSTULA: ", bold: true, fillColor: "#dddddd" },
          { text: `${data.postulante.cargo.descripcion}`, colSpan: 3 },
          {},
          {},
        ],
        [
          {
            text: "DEPARTAMENTO: ",
            bold: true,
            fillColor: "#dddddd",
          },
          { text: data.cargoUP.departamento.descripcion },
          {},
          {},
          
        ],
       
      ],
    },
  },
  {
    marginTop: 10,
    stack: [
      [
        {
          text: "1.	A la fecha Declaro que: No tengo Procesos Administrativos y Penales con sentencia ejecutoriada. Para tal efecto, autorizo al Ministerio de Educación a verificar en las Instituciones donde presté mis servicios. (señalar las Instituciones donde trabajó los últimos 10 años).",
          alignment: "justify",
          fontSize: FontSizeF2,
        },
      ],
    ],
  },
    {},
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "2.	De existir en mi contra Procesos Administrativos y/o Penales con sentencia ejecutoriada, es de mi conocimiento que la postulación al cargo quedará sin efecto o en caso de resultar seleccionada/o mi persona será destituida en el acto y con ello todos sus efectos, por no emitir información fidedigna,   debiendo asumir las sanciones administrativas y/o penales correspondientes, conforme lo establece la Ley No. 1178 Ley de Administración y Control Gubernamentales (SAFCO), Ley Nº 2027 de 27 de octubre de 1999 - Estatuto del Funcionario Público, Ley No. 004 Anticorrupción, “Marcelo Quiroga Santa Cruz”, Código Penal Resolución Ministerial N° 0211/2019 de 22 de marzo de 2019, Resolución Ministerial N° 0042/2021 de 26 de enero de 2021, y otras normas conexas vigentes.",
            alignment: "justify",
            fontSize: FontSizeF2,
          },
        ],
      ],
    },
    
    {
      marginTop: 10,
      stack: [
        [
          {
            text: `Yo: ${data.postulante.c_persona.nombre_completo}, con C.I.${data.postulante.c_persona.cedula_dni}, declaro que todos los datos consignados en el presente formulario son verídicos.`,
            alignment: "justify",
            fontSize: FontSizeF2,
          },
        ],
      ],
    },
    {
      columns: [
        {
          width: "100%",
          fontSize: 10,
          color: "#212121",
          text: `_____________________________________\nFIRMA DE LA O EL DECLARANTE\n${data.cargoUP.departamento.descripcion }, ${this.formatDate(
            data.postulante.fecha_registro
          )}`,
          alignment: "center",
          marginTop: 65,
        },
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "NOTA: El contenido de la presente declaración es de exclusiva responsabilidad del declarante.",
            alignment: "justify",
            fontSize: FontSizeF2,
          },
        ],
      ],
    },
  ];
  if(data.persona_trabajo != "null" && data.persona_trabajo != null && data.persona_trabajo!==""){
    //let persona_trabajos =data.postulante.persona_trabajo!=="" ? JSON.parse(data.postulante.persona_trabajo):"";
    
    //if(Object.keys(persona_trabajos).length > 0 ){
    if(data.persona_trabajo.length>0){ 
      Form2[3]={
        marginTop: 10,
        fontSize: FontSizeF2,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["10%","20%", "20%","15%", "35%"],
          body: [
            [
              {
                text: "GESTIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "INSTITUCIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "CARGO",
              bold: true,
              fillColor: "#dddddd",},
              {text: "TELÉFONO",
              bold: true,
              fillColor: "#dddddd",},
              {text: "LUGAR Y DIRECCION",
              bold: true,
              fillColor: "#dddddd",},
            ],
          ],
        },
      };
      data.persona_trabajo.forEach(dato=>{
        Form2[3].table.body.push([
          {text:dato.gestion.gestion},
          {text:dato.institucion.toUpperCase()},
          {text:dato.cargo.toUpperCase()},
          {text:dato.telefono.toUpperCase()},
          {text:`${dato.departamento.sigla.toUpperCase()}, ${dato.direccion.toUpperCase()}`},
          ])
        }
      );   
    }
  }

let FontSizeF3= 9
  let Form3 = [
    {
      pageBreak: "before",
      stack: [
        // {
        //   fontSize: 12,
        //   bold: true,
        //   color: "#212121",
        //   text: "FORMULARIO N° 3",
        //   alignment: "right",
        //   marginTop: 1,
        // },
        {
          fontSize: 12,
          bold: true,
          color: "#212121",
          text: "FORMULARIO DE DECLARACIÓN DE INCOMPATIBILIDAD LABORAL Y CONFLICTO DE INTERESES",
          alignment: "center",
          marginTop: 10,
        },
        {
          fontSize: 10.5,
          bold: true,
          color: "#212121",
          text: convocatoria.cite,
          alignment: "center",
          marginTop: 2,
        },
        {
          fontSize: 10.5,
          color: "#212121",
          text: convocatoria.descripcion.toUpperCase(),
          alignment: "center",
        },
        // {
        //   fontSize: 12,
        //   bold: true,
        //   color: "#212121",
        //   text: `(Universidad Pedagógica)`,
        //   alignment: "center",
        // },
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "•	Juro que todos los datos declarados en el presente formulario son verídicos. De comprobarse la falsedad de alguno de ellos seré sujeto/a a las sanciones que establece el Marco Legal de la Ley No. 1178 Ley de Administración y Control Gubernamentales (SAFCO), Ley Nº 2027 de 27 de octubre de 1999 - Estatuto del Funcionario Público, Ley No. 004 Anticorrupción, “Marcelo Quiroga Santa Cruz”, Código Penal Resolución Ministerial N° 0211/2019 de 22 de marzo de 2019, Resolución Ministerial N° 0042/2021 de 26 de enero de 2021, y otras normas conexas vigentes.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "•	Asimismo, autorizo expresamente al Ministerio de Educación, a verificar la información proporcionada y me comprometo en caso de ser requerido, a presentar la documentación que sustente lo declarado.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "•	De presentarse modificaciones posteriores a la presente, me comprometo a declarar, inmediatamente las mismas mediante el llenado y presentación de un nuevo formulario.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "1.	DATOS GENERALES DEL DECLARANTE",
            alignment: "justify",
            fontSize: FontSizeF3,
            bold: true,
          },
        ],
      ],
    },
    {
      marginTop: 8,
      fontSize: 9,
      layout: "lightHorizontalLines",
      table: {
        headerRows: 1,
        widths: ["21%", "79%"],
        body: [
          [
            {
              text: "DATOS PERSONALES",
              bold: true,
              colSpan: 2,
              fillColor: "#dddddd",
            },
            {},
          ],
          [
            {
              text: "Apellidos y Nombres: ",
              bold: true,
              fillColor: "#dddddd",
            },
            data.postulante.c_persona.nombre_completo,
          ],
          [
            {
              text: "No. Cédula de Identidad: ",
              bold: true,
              fillColor: "#dddddd",
            },
            data.postulante.c_persona.cedula_dni,
          ],
          [
            {
              text: "RP-SPSEP: ",
              bold: true,
              fillColor: "#dddddd",
            },
            data.postulante.c_persona.rda ? data.postulante.c_persona.rda : "",
          ],
          [
            {
              text: "Fecha de Nacimiento: ",
              bold: true,
              fillColor: "#dddddd",
            },
            this.formatDate(data.postulante.c_persona.fecha_nacimiento),
          ],
          [
            { text: "Genero: ", bold: true, fillColor: "#dddddd" },
            data.postulante.c_persona.genero.descripcion,
          ],
          [
            {
              text: "Teléfono/Celular: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.celular },
          ],
          [
            {
              text: "Domicilio: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.direccion },
          ],
          [
            {
              text: "Correo Electónico: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: data.postulante.c_persona.correo_electronico },
          ],
        ],
      },
    },
    {
      marginTop: 10,
      fontSize: 9,
      layout: "lightHorizontalLines",
      table: {
        headerRows: 1,
        widths: ["20%", "80%"],
        body: [
          [
            {
              text: "DATOS DE POSTULACIÓN",
              bold: true,
              colSpan: 2,
              fillColor: "#dddddd",
            },
            {},
          ],
          [
            { text: "UP: ", bold: true, fillColor: "#dddddd" },
            {
              text: `${data.postulante.institucion.nombre}`,
            },
          ],
          [
            {
              text: "Cargo: ",
              bold: true,
              fillColor: "#dddddd",
            },
            { text: `${data.postulante.cargo.descripcion}`
           },
          ],
        ],
      },
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "2.	DECLARACIÓN DE INCOMPATIBILIDAD",
            alignment: "justify",
            fontSize: FontSizeF3,
            bold: true,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "Declaro a mi leal saber y entender que:",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.1. ", bold:true}, {text:data.datos_incompatibilidad.interes_personal?"SI":"NO", bold:true}, " Tengo intereses de carácter personal, negocios, contratos privados, comerciales, financieros, económicos u otros directos o indirectos con el desempeño de mi función pública y/o con el Ministerio de Educación"
            ],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.2. ", bold:true},{text:data.datos_incompatibilidad.tiene_cargo_otra_institucion?"SI":"NO", bold:true}, " Ejerzo más de una actividad como docente u otro cargo en otras instituciones públicas o privadas (si la respuesta es positiva responda el numeral 2.2.1 y 2.2.2)"],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.2.1 ", bold:true},"De existir incompatibilidad horaria entre esta actividad y aquellas que se deriven de mis nuevas funciones, me comprometo a respetar lo estipulado (Dedicación Exclusiva y a tiempo completo) de acuerdo a la Normativa aplicable a la Universidad Pedagógica."],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
    //tabla 12
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.2.2. ", bold:true},{text:data.datos_incompatibilidad.otra_remuneracion?"SI":"NO", bold:true}, " Percibo remuneración salarial como servidor público, consultor de  línea, consultor por producto u otra actividad mayor o igual al del Sr. Presidente del Estado Plurinacional de Bolivia. Los montos excedentes a la remuneración máxima establecida para el sector público, constituyen deudas imprescriptibles por daño económico al Estado. Artículo 12 del Decreto Supremo 4434"],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      //tabla 14
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.3.	", bold:true},{text:data.datos_incompatibilidad.tiene_parentesco?"SI":"NO", bold:true}, " Tengo miembro (s) de mi familia hasta el 2do grado de consanguinidad y 2do. Grado de afinidad desempeñando cargos y/o funciones en la Universidad Pedagógica con su inmediato superior."],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "2.4	Relaciones de Parentesco: ",
            alignment: "justify",
            fontSize: FontSizeF3,
            bold:true,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "Registrar sólo los parientes con vida, en el siguiente orden: padre, madre, abuelos, hijos, nietos, hermanos, conyugue, suegros, cuñados, yernos, y nueras (Declárelos siempre que sean mayores de 16 años).",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {//tabla 18
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: [{text:"2.5.	", bold:true},{text:data.datos_incompatibilidad.tiene_renta?"SI":"NO", bold:true}, " Recibo del Estado, renta(s) correspondiente(s) a jubilación, subsidios y otros parecidos. (Continúe si la respuesta es positiva)."],
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text:data.datos_incompatibilidad.institucion_renta==""?"": "Estos ingresos, corresponden a mi permanencia en (nombre de la institución donde trabajó):",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {//EMPRESA DONDE TRABAJÓ
      //marginTop: 10,
      marginLeft: 20,
      stack: [
        [
          {
            text: data.datos_incompatibilidad.institucion_renta.toUpperCase(),
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: data.datos_incompatibilidad.cargo_renta==""?"":"Donde desarrollé actividades en el cargo de:",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginLeft: 20,
      stack: [
        [
          {
            text: data.datos_incompatibilidad.cargo_renta.toUpperCase(),
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      marginTop: 10,
      stack: [
        [
          {
            text: "Al considerar lo anterior como un conflicto de interés, corresponde a mi persona a renunciar en el acto, a estos beneficios; así mismo, me comprometo a realizar todos los trámites que se originen de esta decisión.",
            alignment: "justify",
            fontSize: FontSizeF3,
          },
        ],
      ],
    },
    {
      columns: [
        {
          width: "100%",
          fontSize: 10,
          color: "#212121",
          text: `_____________________________________\nFIRMA DE LA O EL DECLARANTE\n ${this.formatDate(
            data.postulante.fecha_registro
          )}`,
          alignment: "center",
          marginTop: 65,
        },
      ],
    },
  ]
  if(data.datos_incompatibilidad.detalle_cargo_otra_institucion != "null" && data.datos_incompatibilidad.detalle_cargo_otra_institucion != null && data.datos_incompatibilidad.detalle_cargo_otra_institucion!==""){
    let detalle_cargo_otra_institucion =data.datos_incompatibilidad.detalle_cargo_otra_institucion!=="" ? JSON.parse(data.datos_incompatibilidad.detalle_cargo_otra_institucion):"";
    
    if(Object.keys(detalle_cargo_otra_institucion).length > 0 ){
      Form3[12]={
        marginTop: 10,
        fontSize: FontSizeF3,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["50%","25%", "25%"],
          body: [
            [
              {
                text: "NOMBRE DE LA INSTITUCIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "TRABAJA DESDE (FECHA)",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "HORARIO",
              bold: true,
              fillColor: "#dddddd",},
            ],
          ],
        },
      };
      detalle_cargo_otra_institucion.forEach(dato=>{
        Form3[12].table.body.push([
          {text:dato.institucion.toUpperCase()},
          {text:dato.fecha},
          {text:dato.horario},
          ])
        }
      );   
    }
  }
  if(data.datos_incompatibilidad.detalle_otra_remuneracion != "null" && data.datos_incompatibilidad.detalle_otra_remuneracion != null && data.datos_incompatibilidad.detalle_otra_remuneracion!==""){
    let detalle_otra_remuneracion =data.datos_incompatibilidad.detalle_otra_remuneracion!=="" ? JSON.parse(data.datos_incompatibilidad.detalle_otra_remuneracion):"";
    
    if(Object.keys(detalle_otra_remuneracion).length > 0 ){
      Form3[14]={
        marginTop: 10,
        fontSize: FontSizeF3,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["35%","33%", "17%", "15%"],
          body: [
            [
              {
                text: "NOMBRE DE LA INSTITUCIÓN",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "CARGO",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "FECHA DE INGRESO",
              bold: true,
              fillColor: "#dddddd",},
              {text: "TOTAL GANADO",
              bold: true,
              fillColor: "#dddddd",},
            ],
          ],
        },
      };
      detalle_otra_remuneracion.forEach(dato=>{
        Form3[14].table.body.push([
          {text:dato.institucion.toUpperCase()},
          {text:dato.cargo.toUpperCase()},
          {text:dato.fecha_ingreso},
          {text:dato.total_ganado},
          ])
        }
      );   
    }
  }

  if(data.parientes != "null" && data.parientes != null && data.parientes!==""){
    //let persona_trabajos =data.postulante.persona_trabajo!=="" ? JSON.parse(data.postulante.persona_trabajo):"";
    
    //if(Object.keys(persona_trabajos).length > 0 ){
    if(data.parientes.length>0){ 
      Form3[18]={
        marginTop: 10,
        fontSize: FontSizeF2,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["25%", "25%","25%", "25%"],
          body: [
            [
              {
                text: "Parentesco",
                bold: true,
                fillColor: "#dddddd",
              },
              {
                text: "Apellido Paterno",
                bold: true,
                fillColor: "#dddddd",
              },
              {text: "Apellido Materno",
              bold: true,
              fillColor: "#dddddd",},
              {text: "Nombres",
              bold: true,
              fillColor: "#dddddd",},
            
            ],
          ],
        },
      };
      data.parientes.forEach(dato=>{
        Form3[18].table.body.push([
          {text:dato.tipo_parentesco.descripcion},
          {text:dato.apellido_paterno.toUpperCase()},
          {text:dato.apellido_materno.toUpperCase()},
          {text:dato.nombres.toUpperCase()},
      
          ])
        }
      );   
    }
  }
  

    let contentbody = [
      {
       stack: [
          {
            fontSize: 12,
            bold: true,
            color: "#212121",
            text: "",
            alignment: "right",
            marginTop: 1,
          },
          {
            marginTop: 10,
            fontSize: 15,
            bold: true,
            color: "#212121",
            text: "FORMULARIO DE POSTULACIÓN",
            alignment: "center",
          },
          {
            fontSize: 10.5,
            bold: true,
            color: "#212121",
            text: convocatoria.cite,
            alignment: "center",
            marginTop: 2,
          },
          {
            fontSize: 10.5,
            color: "#212121",
            text: convocatoria.descripcion.toUpperCase(),
            alignment: "center",
          },
          {
            fontSize: 9,
            bold: true,
            color: "#212121",
            text: `Fecha de Postulación: ${this.formatDate(
              data.postulante.fecha_registro
            )}`,
            alignment: "center",
            marginTop: 4,
          },
        ],
      },
      // {
      //   columns: [
      //     {
      //       width: "100%",
      //       stack: [
      //         {
      //           fontSize: 10,
      //           bold: true,
      //           color: "#424242",
      //           text: "VICEMINISTERIO DE EDUCACIÓN SUPERIOR DE FORMACIÓN PROFESIONAL",
      //           alignment: "center",
      //         },
      //         {
      //           fontSize: 10,
      //           bold: true,
      //           color: "#424242",
      //           text: "DIRECCIÓN GENERAL DE FORMACIÓN DE MAESTROS",
      //           alignment: "center",
      //         },
              
      //       ],
      //     },
      //   ],
      // },
      {
        marginTop: 8,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["21%", "79%"],
          body: [
            [
              {
                text: "DATOS PERSONALES",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              {
                text: "Apellidos y Nombres: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.postulante.c_persona.nombre_completo,
            ],
            [
              {
                text: "No. Cédula de Identidad: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.postulante.c_persona.cedula_dni,
            ],
            [
              {
                text: "RP-SPSEP: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.postulante.c_persona.rda ? data.postulante.c_persona.rda : "",
            ],
            [
              {
                text: "Fecha de Nacimiento: ",
                bold: true,
                fillColor: "#dddddd",
              },
              this.formatDate(data.postulante.c_persona.fecha_nacimiento),
            ],
            [
              { text: "Genero: ", bold: true, fillColor: "#dddddd" },
              data.postulante.c_persona.genero.descripcion,
            ],
            [
              {
                text: "Teléfono/Celular: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.postulante.c_persona.celular },
            ],
            [
              {
                text: "Domicilio: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.postulante.c_persona.direccion },
            ],
            [
              {
                text: "Correo Electónico: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.postulante.c_persona.correo_electronico },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["20%", "80%"],
          body: [
            [
              {
                text: "DATOS DE POSTULACIÓN",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              { text: "UP: ", bold: true, fillColor: "#dddddd" },
              {
                text: `${data.postulante.institucion.nombre}`,
              },
            ],
            [
              {
                text: "Cargo: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: `${data.postulante.cargo.descripcion}`
             },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["20%", "80%"],
          body: [
            [
              {
                text: "COMPROMISO",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              { text: "Dedicación exclusiva de trabajo a tiempo completo en la Universidad Pedagógica.", 
              colSpan: 2,
              },
              {
                
              },
            ],
            // [
            //   { text: "Trabajo en equipo con ética, transparencia y resultados de calidad.", 
            //   colSpan: 2,
            //    },
            //   {
                
            //   },
            // ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["100%"],
          body: [
            [
              {
                text: "DECLARACIÓN JURADA",
                bold: true,
                fillColor: "#dddddd",
              },
            ],
            [{ text: "" }],
          ],
        },
      },
      {
        stack: [
          [
            {
              text: "Declaro bajo juramento, que los datos expuestos en el presente formulario son fehacientes y fidedignos por lo que autorizo que los representantes del Ministerio de Educación, puedan verificar la documentación concerniente a mi persona. En caso de comprobarse falsedad u omisión en los datos presentados o en la documentación adjunta, asumo las consecuencias y sanciones que de mi acción se deriven y tengo conocimiento que seré descalificado en cualquier etapa del Proceso de Institucionalización de Rector/a de la Universidad Pedagógica para las Gestiones Educativas 2025, 2026, 2027, 2028 y 2029 así mismo, asumiré las sanciones administrativas y/ o penales correspondientes, conforme establece la normativa vigente.",
              alignment: "justify",
              fontSize: 8.5,
            },
          ],
          [
            {
              marginTop: 3,
              text: "De igual manera, declaro que no cuento con ninguna causal de impedimento o incompatibilidad para participar en el presente proceso de institucionalización, en caso de acceder al cargo me comprometo a cumplir con todo lo exigido en la convocatoria y desempeñar mis funciones asignadas con dedicación exclusiva a tiempo completo.",
              alignment: "justify",
              fontSize: 8.5,
            },
          ],
          // [
          //   {
          //     marginTop: 3,
          //     text: "Asimismo, declaro NO haberme postulado a más de un cargo de la Universidad Pedagógica, siendo de manera automática mi descalificación del proceso de Compulsa si se verifica lo contrario.",
          //     alignment: "justify",
          //     fontSize: 8.5,
          //   },
          // ],
        ],
      },
      {
        columns: [
          {
            qr: `|COMPULSA-${convocatoria.gestion}|CI-${data.postulante.c_persona.cedula_dni}|FN_${data.postulante.c_persona.fecha_nacimiento}|NO-${codigo}|`,
            marginTop: 10,
            foreground: "#212121",
            fit: "100",
          },
          {
            width: "80%",
            fontSize: 10,
            color: "#212121",
            text: "_______________________________\nFIRMA DEL POSTULANTE",
            alignment: "center",
            marginTop: 65,
          },
        ],
      },
    ];
   // contentbody.push(Form2);
    contentbody.push(Form3);
    const docDefinition = {
      pageSize: "LETTER",
      pageMargins: [60, 75, 60, 50],
      header: this.setting("ri").headerUP,
      footer: this.setting().footer,
      content: contentbody,
    };

    return pdfMake.createPdf(docDefinition).open();
  },
  async certifiedApplicationFormReg(convocatoria, data) {
    const codesize = data.id.toString().length;
    let codigo = "0".repeat(10 - codesize);
    codigo = codigo + data.id;
    let Contentbody = [
      {
        columns: [
          {
            width: "100%",
            stack: [
              {
                fontSize: 10,
                bold: true,
                color: "#424242",
                text: "VICEMINISTERIO DE EDUCACIÓN SUPERIOR DE FORMACIÓN PROFESIONAL",
                alignment: "center",
              },
              {
                fontSize: 10,
                bold: true,
                color: "#424242",
                text: "DIRECCIÓN GENERAL DE FORMACIÓN DE MAESTROS",
                alignment: "center",
              },
              {
                marginTop: 10,
                fontSize: 15,
                bold: true,
                color: "#212121",
                text: "FORMULARIO DE POSTULACIÓN",
                alignment: "center",
              },
              {
                fontSize: 13,
                bold: true,
                color: "#212121",
                text: convocatoria.cite,
                alignment: "center",
                marginTop: 2,
              },
              {
                fontSize: 10.5,
                color: "#212121",
                text: convocatoria.descripcion.toUpperCase(),
                alignment: "center",
              },
              {
                fontSize: 9,
                bold: true,
                color: "#212121",
                text: `Fecha de Postulación: ${this.formatDate(
                  data.fecha_registro
                )}`,
                alignment: "center",
                marginTop: 4,
              },
            ],
          },
        ],
      },
      {
        marginTop: 8,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["21%", "79%"],
          body: [
            [
              {
                text: "DATOS PERSONALES",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              {
                text: "Apellidos y Nombres: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.c_persona.nombre_completo,
            ],
            [
              {
                text: "Cédula de Identidad: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.c_persona.cedula_dni,
            ],
            [
              {
                text: "RDA: ",
                bold: true,
                fillColor: "#dddddd",
              },
              data.c_persona.rda ? data.c_persona.rda : "",
            ],
            [
              {
                text: "Fecha de Nacimiento: ",
                bold: true,
                fillColor: "#dddddd",
              },
              this.formatDate(data.c_persona.fecha_nacimiento),
            ],
            [
              { text: "Genero: ", bold: true, fillColor: "#dddddd" },
              data.c_persona.genero.descripcion,
            ],
            [
              {
                text: "Teléfono/Celular: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.c_persona.celular },
            ],
            [
              {
                text: "Correo Electónico: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.c_persona.correo_electronico },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["20%", "80%"],
          body: [
            [
              {
                text: "DATOS DE POSTULACIÓN",
                bold: true,
                colSpan: 2,
                fillColor: "#dddddd",
              },
              {},
            ],
            [
              { text: "ESFM/UA: ", bold: true, fillColor: "#dddddd" },
              {
                text: `${data.institucion.departamento.descripcion} - ${data.institucion.nombre}`,
              },
            ],
            [
              {
                text: "Cargo: ",
                bold: true,
                fillColor: "#dddddd",
              },
              { text: data.cargo.descripcion },
            ],
          ],
        },
      },
      {
        marginTop: 10,
        fontSize: 9,
        layout: "lightHorizontalLines",
        table: {
          headerRows: 1,
          widths: ["100%"],
          body: [
            [
              {
                text: "DECLARACIÓN JURADA",
                bold: true,
                fillColor: "#dddddd",
              },
            ],
            [{ text: "" }],
          ],
        },
      },
      {
        stack: [
          [
            {
              text: "Declaro bajo juramento, que los datos expuestos en el presente formulario son fehacientes y fidedignos por lo que autorizo que los representantes del Ministerio de Educación puedan verificar la documentación concerniente a mi persona. En caso de comprobarse falsedad en los datos presentados o en la documentación adjunta asumo las consecuencias y sanciones que de mi acción se deriven, siendo descalificado en cualquier etapa del proceso de Compulsa de Méritos Profesionales, sometiéndome a las disposiciones legales vigentes.",
              alignment: "justify",
              fontSize: 8.5,
            },
          ],
          [
            {
              marginTop: 3,
              text: "De igual manera declaro que no cuento con ninguna causal de impedimento o incompatibilidad para participar de la presente Convocatoria Pública, en el caso de acceder al cargo me comprometo a cumplir con todo lo exigido en la convocatoria y desempeñar mis funciones asignadas con dedicación exclusiva a tiempo completo sujeto a evaluación de desempeño profesional.",
              alignment: "justify",
              fontSize: 8.5,
            },
          ],
          [
            {
              marginTop: 3,
              text: "Asimismo, declaro NO haberme postulado a más de una Escuela Superior de Formación de Maestras y Maestros y/o Unidad Académica, cargo y/o especialidad, siendo de manera automática mi descalificación del proceso de Compulsa si se verifica lo contrario.",
              alignment: "justify",
              fontSize: 8.5,
            },
          ],
        ],
      },
      {
        columns: [
          {
            qr: `|COMPULSA-${convocatoria.gestion}|CI-${data.c_persona.cedula_dni}|FN_${data.c_persona.fecha_nacimiento}|NO-${codigo}|`,
            marginTop: 10,
            foreground: "#212121",
            fit: "100",
          },
          {
            width: "80%",
            fontSize: 10,
            color: "#212121",
            text: "_______________________________\nFIRMA DEL POSTULANTE",
            alignment: "center",
            marginTop: 65,
          },
        ],
      },
    ];
    return Contentbody;

  },
  certifiedGenerateCertificate(convocatoria, personal) {
    const codesize = personal.id.toString().length;
    let numero = "0".repeat(4 - codesize);
    numero = numero + personal.id;

    const cdate = new Date();
    let mes = "";
    switch (cdate.getMonth()) {
      case 0:
        mes = "enero";
        break;
      case 1:
        mes = "febrero";
        break;
      case 2:
        mes = "marzo";
        break;
      case 3:
        mes = "abril";
        break;
      case 4:
        mes = "mayo";
        break;
      case 5:
        mes = "junio";
        break;
      case 6:
        mes = "julio";
        break;
      case 7:
        mes = "agosto";
        break;
      case 8:
        mes = "septiembre";
        break;
      case 9:
        mes = "octubre";
        break;
      case 10:
        mes = "noviembre";
        break;
      case 11:
        mes = "diciembre";
        break;
      default:
        break;
    }

    const docDefinition = {
      pageSize: "LETTER",
      pageMargins: [60, 75, 60, 60],
      header: this.setting().header,
      background: [
        {
          image:
            "data:image/jpeg;base64,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",
          width: 610,
        },
      ],
      content: [
        {
          stack: [
            {
              //marginTop: 1,
              fontSize: 10,
              bold: true,
              color: "#212121",
              text: `VICEMINISTERIO DE EDUCACIÓN SUPERIOR Y FORMACIÓN PROFESIONAL\nDIRECCIÓN GENERAL DE FORMACIÓN DE MAESTROS`, // `CITE: DGFM/EGI/CERT No. ${numero}/${convocatoria.gestion}`,
              alignment: "center",
            },
            {
              marginTop: 15,
              fontSize: 18,
              bold: true,
              color: "#212121",
              text: `CERTIFICACIÓN`,
              alignment: "center",
            },
            {
              columns: [
                { width: "50%", text: "" },
                {
                  width: "50%",
                  fontSize: 11,
                  color: "#212121",
                  text: "LA DIRECCIÓN GENERAL DE FORMACIÓN DE MAESTROS, DEPENDIENTE DEL VICEMINISTERIO DE EDUCACIÓN  SUPERIOR Y FORMACIÓN PROFESIONAL DEL MINISTERIO DE EDUCACIÓN EN DERECHO CERTIFICA:",
                  alignment: "justify",
                  marginTop: 10,
                },
                //{ width: "25%", text: "" },
              ],
            },
            {
              fontSize: 11,
              color: "#212121",
              text: [
                {text:`Que, consultada la base de datos de Registro de Procesos Disciplinarios y/o Administrativos de ésta Dirección y de acuerdo a la información remitida por las Escuelas Superiores de Formación de Maestras y Maestros, Universidad Pedagógica y Unidad Especializada de Formación Continua se evidencia que: `
                },
                {
                  text:`${personal.proceso.trim()=="SI"?"SI EXISTE":"NO EXISTE"} `,
                  bold:true
                },
                {
                  text:` ANTECEDENTE DE PROCESOS  ADMINISTRATIVOS Y/O DISCIPLINARIOS CON RESOLUCION FINAL SANCIONATORIA EN SEDE ADMINISTRATIVA, CORRESPONDIENTE A LAS ESCUELAS SUPERIORES DE FORMACIÓN DE MAESTROS / UNIDADES ACADÉMICAS / UNIVERSIDAD PEDAGOGICA / UNIDAD ESPECIALIZADA DE FORMACION CONTINUA, correspondiente a:`,
                }
              ],
              alignment: "justify",
              marginTop: 30,
            },
            {
              fontSize: 14,
              bold: true,
              text: `${personal.nombre.toUpperCase()} CON C.I.: ${personal.cedula_dni}`,
              alignment: "center",
              marginTop: 20,
            },
            {
              fontSize: 11,
              text: "La presente certificación, es válida únicamente para trámite de Compulsa de Méritos Profesionales para la Estructura de Formación de Maestras y Maestros.",
              alignment: "justify",
              marginTop: 10,
            },
            {
              fontSize: 11,
              color: "#212121",
              text: "Es cuanto certifica en honor a la verdad, para fines consiguientes. ",
              alignment: "justify",
              marginTop: 20,
            },
            {
              fontSize: 11,
              color: "#212121",
              text: `La Paz, ${cdate.getDate()} de ${mes} de ${cdate.getFullYear()}`,
              alignment: "right",
              marginTop: 40,
            },
            {
              fontSize: 9,
              color: "#212121",
              text: `Nota: La presente no certifica, la existencia o inexistencia de procesos en la vía ordinaria (Penal, Civil, Familiar)`,
              alignment: "left",
              marginTop: 20,
            },
            {
              qr: `|COMPULSA|CI-${
                personal.cedula_dni
              }|CODE-${General.strencdec(numero, 8)}|${personal.proceso.trim()=="SI"?"SI EXISTE PROCESO":"NO EXISTE PROCESO"} `,
              marginTop: 10,
              foreground: "#212121",
              fit: "100",
            },
          ],
        },
      ],
    };
    pdfMake.createPdf(docDefinition).open();
  },
  statisticalReportPDF(
    announcement,
    dato,
    totalGral,
    totalAptitude,
    totalWritten,
    totalObserved
  ) {
    let allTables = [
      {
        fontSize: 15,
        bold: true,
        color: "#212121",
        text: `${announcement.cite}`,
        alignment: "center",
      },
      {
        fontSize: 12,
        color: "#424242",
        text: `${announcement.descripcion.toUpperCase()} GESTIÓN ${
          announcement.gestion
        }`,
        alignment: "center",
      },
      {
        marginTop: 10,
        fontSize: 13,
        bold: true,
        color: "#212121",
        text: "REPORTE ESTADÍSTICO",
        alignment: "center",
      },
    ];
    const titleInscribed = {
      marginTop: 15,
      fontSize: 9,
      layout: "lightHorizontalLines",
      table: {
        headerRows: 1,
        widths: ["100%"],
        body: [
          [
            {
              text: "CANTIDAD DE POSTULANTES INSCRITOS",
              bold: true,
              fillColor: "#dddddd",
            },
          ],
          [""],
        ],
      },
    };
    allTables.push(titleInscribed);

    let tblInscribed = {
      marginTop: 3,
      fontSize: 9,
      table: {
        headerRows: 1,
        widths: ["60%", "40%"],
        body: [
          [
            {
              text: "Modalidad",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Cantidad",
              bold: true,
              fillColor: "#dddddd",
            },
          ],
        ],
      },
    };
    dato.modalidades.forEach((item) => {
      tblInscribed.table.body.push([item.sigla, item.cantidad]);
    });
    tblInscribed.table.body.push([
      { text: "Total", bold: true, alignment: "center" },
      { text: totalGral, bold: true },
    ]);
    allTables.push(tblInscribed);

    const titleModality = {
      marginTop: 20,
      fontSize: 9,
      layout: "lightHorizontalLines",
      table: {
        headerRows: 1,
        widths: ["100%"],
        body: [
          [
            {
              text: "MODALIDAD A",
              bold: true,
              fillColor: "#dddddd",
            },
          ],
          [""],
        ],
      },
    };
    allTables.push(titleModality);

    let tblAptitude = {
      marginTop: 3,
      fontSize: 9,
      table: {
        headerRows: 1,
        widths: ["60%", "40%"],
        body: [
          [
            {
              text: "Cantidad de postulantes con prueba de aptitud",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Cantidad",
              bold: true,
              fillColor: "#dddddd",
            },
          ],
        ],
      },
    };
    dato.prueba_aptitud.forEach((item) => {
      tblAptitude.table.body.push([item.descripcion, item.cantidad]);
    });
    tblAptitude.table.body.push([
      { text: "Total habilitados", bold: true, alignment: "center" },
      { text: totalAptitude, bold: true },
    ]);
    allTables.push(tblAptitude);

    let tblWritten = {
      marginTop: 10,
      fontSize: 9,
      table: {
        headerRows: 1,
        widths: ["60%", "40%"],
        body: [
          [
            {
              text: "Cantidad de postulantes habilitados a prueba escrita",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Cantidad",
              bold: true,
              fillColor: "#dddddd",
            },
          ],
        ],
      },
    };
    dato.prueba_escrita.forEach((item) => {
      tblWritten.table.body.push([item.descripcion, item.cantidad]);
    });
    tblWritten.table.body.push([
      { text: "Total habilitados", bold: true, alignment: "center" },
      { text: totalWritten, bold: true },
    ]);
    allTables.push(tblWritten);

    let tblObserved = {
      pageBreak: "after",
      marginTop: 10,
      fontSize: 9,
      table: {
        headerRows: 1,
        widths: ["60%", "40%"],
        body: [
          [
            {
              text: "Cantidad de observados",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Cantidad",
              bold: true,
              fillColor: "#dddddd",
            },
          ],
        ],
      },
    };
    dato.observados.forEach((item) => {
      tblObserved.table.body.push([item.descripcion, item.cantidad]);
    });
    tblObserved.table.body.push([
      {
        text: "Total observados y los que no se presentaron",
        bold: true,
        alignment: "center",
      },
      { text: totalObserved, bold: true },
    ]);
    allTables.push(tblObserved);

    allTables.push(
      {
        fontSize: 15,
        bold: true,
        color: "#212121",
        text: `${announcement.cite}`,
        alignment: "center",
      },
      {
        fontSize: 12,
        color: "#424242",
        text: `${announcement.descripcion.toUpperCase()} GESTIÓN ${
          announcement.gestion
        }`,
        alignment: "center",
      },
      {
        marginTop: 10,
        bold: true,
        alignment: "center",
        text: "CANTIDAD DE POSTULANTES INSCRITOS POR ESFM/UA",
      }
    );

    let tblInstitutions = {
      pageBreak: "after",
      marginTop: 10,
      fontSize: 9,
      table: {
        headerRows: 1,
        widths: ["5%", "25%", "60%", "10%"],
        body: [
          [
            {
              text: "Nro",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Departamento",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "ESFM/UA",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Cantidad",
              bold: true,
              fillColor: "#dddddd",
            },
          ],
        ],
      },
    };
    dato.instituciones.forEach((item, index) => {
      tblInstitutions.table.body.push([
        index + 1,
        item.descripcion,
        item.nombre,
        item.total,
      ]);
    });
    tblInstitutions.table.body.push([
      { bold: true, alignment: "center", text: "Total", colSpan: 3 },
      {},
      {},
      { bold: true, text: totalGral },
    ]);
    allTables.push(tblInstitutions);

    allTables.push(
      {
        fontSize: 15,
        bold: true,
        color: "#212121",
        text: `${announcement.cite}`,
        alignment: "center",
      },
      {
        fontSize: 12,
        color: "#424242",
        text: `${announcement.descripcion.toUpperCase()} GESTIÓN ${
          announcement.gestion
        }`,
        alignment: "center",
      },
      {
        marginTop: 10,
        bold: true,
        alignment: "center",
        text: "CANTIDAD DE HABILITADOS A VALORACIÓN DE LENGUA ORIGINARIA POR ESFM/UA",
      }
    );

    let tblEnabled = {
      marginTop: 10,
      fontSize: 9,
      table: {
        headerRows: 1,
        widths: ["5%", "25%", "60%", "10%"],
        body: [
          [
            {
              text: "Nro",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Departamento",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "ESFM/UA",
              bold: true,
              fillColor: "#dddddd",
            },
            {
              text: "Cantidad",
              bold: true,
              fillColor: "#dddddd",
            },
          ],
        ],
      },
    };
    dato.aptitudes.forEach((item, index) => {
      tblEnabled.table.body.push([
        index + 1,
        item.descripcion,
        item.nombre,
        item.total,
      ]);
    });
    tblEnabled.table.body.push([
      { bold: true, alignment: "center", text: "Total", colSpan: 3 },
      {},
      {},
      { bold: true, text: totalAptitude },
    ]);
    allTables.push(tblEnabled);
    return allTables;
  },
  reportAdmittedModA(announcement, data) {
    let tableContent = {
      fontSize: 7,
      table: {
        
        headerRows: 1,
        widths: [
          "3%",
          "7%",
          "27%",
          "30%",
          "21%",
          "5%",
          "4%",
          "3%",
        ],
        body: [
          [
            {
              text: "Nro.",
              bold: true,
              fillColor: "#dddddd",
            //  rowSpan: 2,
              alignment: "center",
            },
            {
              text: "Departamento",
              bold: true,
              fillColor: "#dddddd",
             // rowSpan: 2,
              alignment: "center",
            },
            {
              text: "ESFM/UA",
              bold: true,
              fillColor: "#dddddd",
            //  rowSpan: 2,
              alignment: "center",
            },
            {
              text: "Especialidad",
              bold: true,
              fillColor: "#dddddd",
            //  rowSpan: 2,
              alignment: "center",
            },
            {
              text: "Apellidos y Nombres",
              bold: true,
              fillColor: "#dddddd",
            //  rowSpan: 2,
              alignment: "center",
            },
            {
              text: "Cédula Identidad",
              bold: true,
              fillColor: "#dddddd",
             // rowSpan: 2,
              alignment: "center",
            },
            // {
            //   text: "Evaluación de lengua Orginaria",
            //   bold: true,
            //   fillColor: "#dddddd",
            //   colSpan: 2,
            //   alignment: "center",
            // },
            // {},
            {
              text: "Prueba escrita",
              bold: true,
              fillColor: "#dddddd",
            //  colSpan: 2,
              alignment: "center",
            },
            // {},
            {
              text: "Total",
              bold: true,
              fillColor: "#dddddd",
            //  rowSpan: 2,
              alignment: "center",
            },
          ],
          // [
          //   {},
          //   {},
          //   {},
          //   {},
          //   {},
          //   {},
          //   {
          //     text: "Puntaje",
          //     bold: true,
          //     fillColor: "#dddddd",
          //     alignment: "center",
          //   },
          //   {
          //     text: "30%",
          //     bold: true,
          //     fillColor: "#dddddd",
          //     alignment: "center",
          //   },
          //   {
          //     text: "Puntaje",
          //     bold: true,
          //     fillColor: "#dddddd",
          //     alignment: "center",
          //   },
          //   {
          //     text: "70%",
          //     bold: true,
          //     fillColor: "#dddddd",
          //     alignment: "center",
          //   },
          //   {},
          // ],
        ],
       
      },
    };
    let institution = "",
      indexSpeciality = 1,
      speciality = "";
  //  let nota_aptitud, porcentaje_aptitud, porcentaje_escrita;
    let rbreak = null;
    data.forEach((item, index) => {
      if (indexSpeciality > 0 && speciality !== item.especialidad.descripcion) {
        indexSpeciality = 1;
        speciality = item.especialidad.descripcion;
      }
    //  nota_aptitud = porcentaje_aptitud = porcentaje_escrita = "-";
     // if (item.nota_aptitud !== null) {
      //  nota_aptitud = item.nota_aptitud;
     //   porcentaje_aptitud = (item.porcentaje_aptitud * 1).toFixed(2);
      //  porcentaje_escrita = (item.porcentaje_escrita * 1).toFixed(2);
     // }
      if (index === 0) {
        institution = item.institucion.nombre;
      }
      rbreak = null;
      if (institution !== item.institucion.nombre) {
        institution = item.institucion.nombre;
        indexSpeciality = 1;
        rbreak = "before";
      }
      tableContent.table.body.push([
        { text: indexSpeciality++, pageBreak: rbreak },
        {
          text: item.institucion.departamento.descripcion,
          pageBreak: rbreak,
        },
        { text: item.institucion.nombre, pageBreak: rbreak },
        { text: item.especialidad.descripcion, pageBreak: rbreak },
        {
          text: item.a_postulante.a_persona.nombre_completo,
          pageBreak: rbreak,
        },
        { text: item.a_postulante.a_persona.cedula_dni, pageBreak: rbreak },
      //  { text: nota_aptitud, alignment: "center", pageBreak: rbreak },
      //  { text: porcentaje_aptitud, alignment: "center", pageBreak: rbreak },
        { text: item.nota_escrita, alignment: "center", pageBreak: rbreak },
      //  { text: porcentaje_escrita, alignment: "center", pageBreak: rbreak },
        { text: item.resultado, alignment: "center", pageBreak: rbreak },
      ]);
    });
    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "landscape",
      pageMargins: [30, 122, 30, 25],
    
      header: [
        {
          image: this.logoH(),
          width: 240,
          height: 52,
          margin: [35, 16, 35, 0],
        },
        {
          fontSize: 11,
          bold: true,
          color: "#212121",
          text: announcement.cite,
          alignment: "center",
        },
        {
          columns: [
            { text: "", width: 150 },
            {
              fontSize: 10.4,
              color: "#212121",
              text: announcement.descripcion.toUpperCase(),
              alignment: "center",
            },
            { text: "", width: 150 },
          ],
        },
        {
          marginTop: 3,
          marginBottom: 3,
          fontSize: 11,
          bold: true,
          color: "#212121",
          text: `RESULTADO FINAL ADMISIÓN ${announcement.gestion} - MODALIDAD A`,
          alignment: "center",
        },
      ],
      footer: this.setting().footer,
      content: tableContent,
    };
    pdfMake.createPdf(docDefinition).download("AdmitidosModalidadA.pdf");
  },
  reportAdmittedModB(announcement, data) {
    let tableContent = {
      fontSize: 7,
      table: {
        headerRows: 1,
        widths: ["4%", "8%", "25%", "25%", "23%", "8%", "7%"],
        body: [
          [
            {
              text: "Nro.",
              bold: true,
              fillColor: "#dddddd",
              alignment: "center",
            },
            {
              text: "Departamento",
              bold: true,
              fillColor: "#dddddd",
              alignment: "center",
            },
            {
              text: "ESFM/UA",
              bold: true,
              fillColor: "#dddddd",
              alignment: "center",
            },
            {
              text: "Especialidad",
              bold: true,
              fillColor: "#dddddd",
              alignment: "center",
            },
            {
              text: "Apellidos y Nombres",
              bold: true,
              fillColor: "#dddddd",
              alignment: "center",
            },
            {
              text: "Cédula Identidad",
              bold: true,
              fillColor: "#dddddd",
              alignment: "center",
            },
            {
              text: "Modalidad",
              bold: true,
              fillColor: "#dddddd",
              alignment: "center",
            },
          ],
        ],
      },
    };
    let institution = "",
      indexIntitution = 1;
    let rbreak = null;
    data.forEach((item, index) => {
      if (index === 0) {
        institution = item.institucion.nombre;
      }
      rbreak = null;
      if (institution !== item.institucion.nombre) {
        institution = item.institucion.nombre;
        indexIntitution = 1;
        rbreak = "before";
      }
      tableContent.table.body.push([
        { text: indexIntitution++, pageBreak: rbreak },
        {
          text: item.institucion.departamento.descripcion,
          pageBreak: rbreak,
        },
        { text: item.institucion.nombre, pageBreak: rbreak },
        { text: item.especialidad.descripcion, pageBreak: rbreak },
        {
          text: item.a_persona.nombre_completo,
          pageBreak: rbreak,
        },
        { text: item.a_persona.cedula_dni, pageBreak: rbreak },
        { text: item.modalidad.sigla, alignment: "center", pageBreak: rbreak },
      ]);
    });
    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "landscape",
      pageMargins: [32, 122, 32, 30],
      header: [
        {
          image: this.logoH(),
          width: 240,
          height: 52,
          margin: [35, 16, 35, 0],
        },
        {
          fontSize: 11,
          bold: true,
          color: "#212121",
          text: announcement.cite,
          alignment: "center",
        },
        {
          columns: [
            { text: "", width: 150 },
            {
              fontSize: 10.4,
              color: "#212121",
              text: announcement.descripcion.toUpperCase(),
              alignment: "center",
            },
            { text: "", width: 150 },
          ],
        },
        {
          marginTop: 3,
          marginBottom: 3,
          fontSize: 11,
          bold: true,
          color: "#212121",
          text: `RESULTADO FINAL ADMISIÓN ${announcement.gestion} - MODALIDAD B`,
          alignment: "center",
        },
      ],
      footer: this.setting().footer,
      content: tableContent,
    };
    pdfMake.createPdf(docDefinition).download("AdmitidosModalidadB.pdf");
  },
  currentDateLiteral() {
    const cdate = new Date();
    let mes = "";
    switch (cdate.getMonth()) {
      case 0:
        mes = "enero";
        break;
      case 1:
        mes = "febrero";
        break;
      case 2:
        mes = "marzo";
        break;
      case 3:
        mes = "abril";
        break;
      case 4:
        mes = "mayo";
        break;
      case 5:
        mes = "junio";
        break;
      case 6:
        mes = "julio";
        break;
      case 7:
        mes = "agosto";
        break;
      case 8:
        mes = "septiembre";
        break;
      case 9:
        mes = "octubre";
        break;
      case 10:
        mes = "noviembre";
        break;
      case 11:
        mes = "diciembre";
        break;
      default:
        break;
    }
    return `Es dado a los ${cdate.getDate()} días, del mes de ${mes} de ${cdate.getFullYear()}`;
  },
  formatDate(fecha) {
    if (!fecha) return null;

    const [year, month, day] = fecha.substring(0, 10).split("-");
    return `${day}/${month}/${year}`;
  },
  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
  
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
  
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
  
        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
  
      img.onerror = error => {
        reject(error);
      };
  
      img.src = url;
    });
  },
};
